import React from "react";
import {
  Typography,
  Button,
  Avatar,
  Menu,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
  Backdrop,
  Tooltip,
  TextareaAutosize,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import API from "../API";
import dayjs, { Dayjs } from "dayjs";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ErrorIcon from "@mui/icons-material/Error";
import { Document, Page } from "react-pdf";
import { trTR } from "@mui/x-date-pickers/locales";
import { Link } from "react-router-dom";
import { tr } from "date-fns/locale";
import Rating from "@mui/material/Rating";
import "dayjs/locale/tr";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReactAudioPlayer from "react-audio-player";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import Review from "../components/Review";
import TimetableComponent from "../components/TimetableComponent";
import ItemDescription from "../components/ItemDesc";
import JYSKTimetableComponent from "../components/JYSKTimetableComponent";
import SearchBarComponent from "../components/SearchBarComponent";
import ForumIcon from "@mui/icons-material/Forum";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { MuiTelInput } from "mui-tel-input";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import OrderIDTableCell from "../components/OrderIDTableCell";
import BusinessBadge from "../components/BusinessBadge";
// import convertHTMLToPDF from 'pdf-puppeteer';
// const FILES = ["Sürücü Belgesi Ön", "Sürücü Belgesi Arka", "İkametgah Belgesi", "Adli Sicil Kaydı", "Profil Fotoğrafı"];
const VEHICLE_NAMES = [
  "Motorsiklet",
  "Sedan",
  "Doblo",
  "Minivan",
  "Panelvan",
  "Kamyonet",
  "Esnek",
];
const VEHICLE_TIMES = [5, 15, 15, 15, 20, 30];
var IN_EDIT_MODE = false;

const greenIcon = new L.Icon({
  iconUrl: "http://maps.google.com/mapfiles/ms/icons/green.png",
  iconAnchor: [16, 32],
  iconSize: [32, 32],
});
const createMapMarkerIcon = ({ backgroundColor, iconSvg, shadowColor }) =>
  L.divIcon({
    className: "order-map-marker-icon",
    iconSize: [40, 54],
    iconAnchor: [20, 50],
    popupAnchor: [0, -42],
    html: `
      <div style="position:relative;width:40px;height:54px;display:flex;align-items:flex-start;justify-content:center;">
        <div style="position:relative;z-index:2;width:40px;height:40px;border-radius:14px;background:${backgroundColor};border:2px solid #ffffff;box-shadow:0 12px 30px ${shadowColor};display:flex;align-items:center;justify-content:center;">
          ${iconSvg}
        </div>
        <div style="position:absolute;left:50%;bottom:4px;width:16px;height:16px;background:${backgroundColor};transform:translateX(-50%) rotate(45deg);border-radius:4px;box-shadow:0 12px 30px ${shadowColor};"></div>
      </div>
    `,
  });
const createVehicleImageMarkerIcon = (imageUrl) =>
  L.divIcon({
    className: "order-map-vehicle-icon",
    iconSize: [60, 60],
    iconAnchor: [30, 30],
    popupAnchor: [0, -24],
    html: `
      <div style="width:60px;height:60px;display:flex;align-items:center;justify-content:center;">
        <img src="${imageUrl}" alt="Arac" style="width:60px;height:60px;object-fit:contain;display:block;filter:drop-shadow(0 8px 14px rgba(15,23,42,0.18));" />
      </div>
    `,
  });
const VEHICLE_MARKER_IMAGES = {
  0: "/Motor.png",
  1: "/Motor.png",
  2: "/Doblo.png",
  3: "/Motor.png",
  4: "/Panelvan.png",
  5: "/Kamyonet.png",
};
const DEFAULT_VEHICLE_MARKER_IMAGE = "/Panelvan.png";
const getDriverMapIcon = (vehicleType) =>
  createVehicleImageMarkerIcon(
    VEHICLE_MARKER_IMAGES[vehicleType] || DEFAULT_VEHICLE_MARKER_IMAGE,
  );
const pickupMapIcon = createMapMarkerIcon({
  backgroundColor: "#059669",
  shadowColor: "rgba(5, 150, 105, 0.28)",
  iconSvg:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21C12 21 18 15.6 18 10.5C18 7.46 15.31 5 12 5C8.69 5 6 7.46 6 10.5C6 15.6 12 21 12 21Z" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.75 10.5H14.25M12 8.25V12.75" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
});
const ORDER_TYPE_LABELS = {
  new: "Yeni",
  refund: "İade",
  return: "Geri Dönüş",
  damaged: "Hasarlı",
  replaced: "Değiştirildi",
  wrongProduct: "Yanlış Ürün",
  onlineReturn: "Online İade",
  marketing: "Pazarlama",
  promotion: "Promosyon",
};
const ORDER_INVOICE_TYPE_LABELS = {
  eArsiv: "E-Arşiv",
  eFatura: "E-Fatura",
};
const ORDER_INVOICE_TYPE_OPTIONS = ["eArsiv", "eFatura"];
const DISTANCE_FORMATTER = new Intl.NumberFormat("tr-TR", {
  maximumFractionDigits: 2,
});
const CURRENCY_FORMATTER = new Intl.NumberFormat("tr-TR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
//TEST

var STATUS = {};
STATUS[0] = {
  t: "Sürücü Aranıyor",
  color: "rgb(80,72,229)",
};
STATUS[1] = {
  t: "Planlanmış",
  color: "rgb(80,72,229)",
};
STATUS[2] = {
  t: "Aktif Sipariş",
  color: "orange",
};
STATUS[3] = {
  t: "Tarih Kesinleştirildi",
  color: "rgb(80,72,229)",
};
STATUS[10] = {
  t: "Tamamlanmış",
  color: "green",
};
STATUS[11] = {
  t: "Müşteri İptal",
  color: "yellow",
};
STATUS[-1] = STATUS[11];
STATUS[12] = {
  t: "Sürücü İptali",
  color: "crimson",
};

const formatOrderDistance = (distance) => {
  const numericDistance = Number(distance);

  if (!Number.isFinite(numericDistance) || numericDistance < 0) return "-";

  return `${DISTANCE_FORMATTER.format(numericDistance)} km`;
};

const calculateDistanceInKm = (fromCoordinates, toCoordinates) => {
  if (
    !Array.isArray(fromCoordinates) ||
    !Array.isArray(toCoordinates) ||
    fromCoordinates.length < 2 ||
    toCoordinates.length < 2
  ) {
    return undefined;
  }

  const [fromLng, fromLat] = fromCoordinates;
  const [toLng, toLat] = toCoordinates;
  const values = [fromLng, fromLat, toLng, toLat].map(Number);

  if (values.some((value) => !Number.isFinite(value))) return undefined;

  const toRadians = (value) => (value * Math.PI) / 180;
  const earthRadiusInKm = 6371;
  const deltaLat = toRadians(toLat - fromLat);
  const deltaLng = toRadians(toLng - fromLng);
  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(toRadians(fromLat)) *
      Math.cos(toRadians(toLat)) *
      Math.sin(deltaLng / 2) *
      Math.sin(deltaLng / 2);

  return earthRadiusInKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const formatEstimatedPickupEta = (distanceInKm) => {
  const numericDistance = Number(distanceInKm);

  if (!Number.isFinite(numericDistance) || numericDistance < 0) return "-";

  const estimatedMinutes = Math.max(2, Math.round((numericDistance / 30) * 60));
  return convertMillisToTimeString(estimatedMinutes * 60 * 1000);
};

const formatManageOrderAmount = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) return "-";

  return `${CURRENCY_FORMATTER.format(numericValue)} TL`;
};

const getManageOrderStatusLabel = (status) => {
  if (!status) return "-";
  if (status === "pending_driver_approval") return "Sürücü onayı bekleniyor";
  if (status === "awaiting_payment") return "Ödeme bekleniyor";
  if (status === "approved") return "Onaylandı";
  if (status === "rejected") return "Reddedildi";
  if (status === "resolved") return "Çözüldü";
  if (status === "cash_confirmed") return "Nakit onaylandı";

  return status
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const getManageOrderRequestTitle = (request) => {
  if (request?.title) return request.title;
  if (request?.type === "datetime") return "Tarih Güncellendi";
  if (request?.type === "address") return "Adres Güncellendi";
  if (request?.type === "payment_method") return "Ödeme Yöntemi Değişti";
  if (request?.type === "pricing") return "Fiyat Güncellendi";
  if (request?.type === "distance") return "Mesafe Güncellendi";
  if (request?.type === "time") return "Süre Güncellendi";
  if (request?.type === "help") return "Yardım Talebi";

  return request?.type
    ? request.type
        .split("_")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ")
    : "Talep";
};

const getManageOrderPaymentMethodLabel = (paymentMethod) => {
  if (!paymentMethod && paymentMethod !== 0) return "Bilinmiyor";
  const type = typeof paymentMethod === "object" ? paymentMethod?.type : undefined;
  const code = typeof paymentMethod === "object" ? paymentMethod?.code : paymentMethod;

  if (type === "cash" || code === 1) return "Nakit";
  if (type === "door_online" || code === 5) return "Kapıda Online Kart";
  if (type === "cashless_pos" || code === 6) return "Cari Hesap";
  if (type === "card" || code === 0 || typeof code === "string") return "Kredi Kartı";

  return "Bilinmiyor";
};

const getManageOrderWaypointLabel = (waypoint) => {
  if (!waypoint) return "—";
  if (waypoint.Label) return waypoint.Label;
  if (waypoint.label) return waypoint.label;
  if (waypoint.address) return waypoint.address;
  if (Array.isArray(waypoint.coordinates)) return waypoint.coordinates.join(", ");
  if (Array.isArray(waypoint.Point)) return waypoint.Point.join(", ");

  return "—";
};

const buildManageOrderFeedItem = (request) => {
  if (!request) return null;

  if (request.type === "address") {
    const oldWaypoints = request?.oldValue?.waypoints || [];
    const newWaypoints = request?.newValue?.waypoints || [];
    const firstChangedIndex = newWaypoints.findIndex(
      (waypoint, index) =>
        getManageOrderWaypointLabel(waypoint) !==
        getManageOrderWaypointLabel(oldWaypoints[index]),
    );
    const changedIndex = firstChangedIndex >= 0 ? firstChangedIndex : 0;

    return {
      id: request._id,
      variant: "blue",
      title: "Adres Güncellendi",
      summary:
        `${getManageOrderWaypointLabel(newWaypoints[changedIndex])}` +
        (request?.recalculation?.difference > 0
          ? ` · +${formatManageOrderAmount(request.recalculation.difference)}`
          : ""),
      oldValue: getManageOrderWaypointLabel(oldWaypoints[changedIndex]),
      newValue: getManageOrderWaypointLabel(newWaypoints[changedIndex]),
      meta:
        request?.recalculation?.difference > 0
          ? `Fiyat farkı: +${formatManageOrderAmount(
              request.recalculation.difference,
            )}`
          : "Adres güncellendi",
      time: request?.createdAt || request?.respondedAt,
      status: request?.status,
      preserveWhitespace: false,
    };
  }

  if (request.type === "datetime") {
    return {
      id: request._id,
      variant: "amber",
      title: "Tarih Güncellendi",
      summary: `${API.formatDateTR(request?.oldValue?.date)} → ${API.formatDateTR(
        request?.newValue?.date,
      )}`,
      oldValue: API.formatDateTR(request?.oldValue?.date),
      newValue: API.formatDateTR(request?.newValue?.date),
      meta: getManageOrderStatusLabel(request?.status),
      time: request?.createdAt || request?.respondedAt,
      status: request?.status,
      preserveWhitespace: false,
    };
  }

  if (request.type === "payment_method") {
    const oldPaymentMethod = request?.oldValue?.paymentMethod ?? request?.oldValue;
    const newPaymentMethod = request?.newValue?.paymentMethod ?? request?.newValue;
    const nextLabel = getManageOrderPaymentMethodLabel(newPaymentMethod);

    return {
      id: request._id,
      variant: "green",
      title: "Ödeme Yöntemi Değişti",
      summary: `${getManageOrderPaymentMethodLabel(
        oldPaymentMethod,
      )} → ${nextLabel}`,
      oldValue: getManageOrderPaymentMethodLabel(oldPaymentMethod),
      newValue: nextLabel,
      meta:
        nextLabel === "Nakit"
          ? "Bu sipariş için ödemeyi nakit yapacaksınız."
          : `Güncel ödeme yöntemi: ${nextLabel}`,
      time: request?.createdAt || request?.respondedAt,
      status: request?.status,
      preserveWhitespace: false,
    };
  }

  return null;
};

const getPanelPaymentMethodLabel = (paymentMethod) =>
  paymentMethod == 1
    ? "Nakit Ödeme"
    : paymentMethod == 5
      ? "Kapıda Online Kart"
      : paymentMethod == 6
        ? "Cari Hesap"
        : "Kredi Kartı";

const getOrderIncidentSummary = (order) => {
  if (order?.status == -1) {
    return {
      title: "Müşteri İptali",
      subtitle: "Sipariş üzerinde iptal kaydı bulunuyor",
      tone: "#BA1A1A",
      badge: "Müşteri Tarafından İptal",
      badgeBackground: "#FFDAD6",
      badgeColor: "#93000A",
    };
  }

  if (order?.status == 12) {
    return {
      title: "Sürücü İptali",
      subtitle: "Sürücü ataması iptal edildi",
      tone: "#BA1A1A",
      badge: "Sürücü İptal Etti",
      badgeBackground: "#FFE4E6",
      badgeColor: "#B42318",
    };
  }

  return {
    title: STATUS[order?.status]?.t || "Sipariş Aktif",
    subtitle: "Sipariş şu anda devam ediyor",
    tone: "#0B1C30",
    badge: STATUS[order?.status]?.t || "Aktif",
    badgeBackground: "#E0E7FF",
    badgeColor: "#3525CD",
  };
};

const getTimelineTone = (label = "") => {
  const normalized = label.toLowerCase();

  if (normalized.includes("iptal") || normalized.includes("cancel")) {
    return { dot: "#BA1A1A", ring: "#FFDAD6" };
  }

  if (
    normalized.includes("sürücü atandı") ||
    normalized.includes("assigned") ||
    normalized.includes("onay")
  ) {
    return { dot: "#005338", ring: "#D7FBE9" };
  }

  return { dot: "#3525CD", ring: "#E0E7FF" };
};

const orderCancelReasons = [
  "Yanlışlıkla aldım",
  "Trafik",
  "Aracıma sığmadı",
  "Kaza veya doğal afet",
  "Diğer",
];

const AcqusitionTypes = {};
AcqusitionTypes[-1] = "Diğer";
AcqusitionTypes[0] = "Instagram";
AcqusitionTypes[1] = "Facebook";
AcqusitionTypes[2] = "Google";
AcqusitionTypes[3] = "Arkadaş/Öneri";
AcqusitionTypes[4] = "Uygulama Mağazası";

class Recording extends React.Component {
  constructor(props) {
    super(props);

    this.state = { count: 0, loading: false, url: undefined };
  }

  render() {
    const callUpdate = this.props.order.updates?.find(
      (s) => s.callId == this.props.history.data.call,
    );

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href={
              "https://oim.verimor.com.tr/switch/reports/cdrs/" +
              this.props.history.data.call
            }
            target="_blank"
          >
            <Typography style={{ marginRight: "5px" }}>
              {(this.props.history.data.p ? "Sürücü" : "Müşteri") + " Araması"}
            </Typography>
          </a>
          {!this.state.loading && this.state.url == undefined && (
            <a
              href="#"
              onClick={() => {
                this.setState({ loading: true });

                API.fetch("getrecording", {
                  id: this.props.history.data.call,
                }).then((e) => {
                  if (e.url) {
                    this.setState({ loading: false, url: e.url });
                  } else {
                    this.setState({ loading: false });
                  }
                });
              }}
            >
              Dinle{" "}
            </a>
          )}

          {this.state.url != undefined && !this.state.loading && (
            <ReactAudioPlayer
              style={{ display: "inline", maxWidth: "100%" }}
              autoPlay
              controls
              src={this.state.url}
            />
          )}
          {/* {this.state.url != undefined && !this.state.loading && <div><audio style={{display:"inline",maxWidth:"100%"}} autoPlay controls><source src={this.state.url}  /></audio></div>} */}
          {this.state.loading && <CircularProgress size={18} />}

          {callUpdate && (
            <div
              style={{
                borderRadius: 10,
                padding: 8,
                paddingTop: 2,
                paddingBottom: 2,
                width: "fit-content",
                backgroundColor:
                  callUpdate.callStatus == 10
                    ? "green"
                    : callUpdate.callStatus == 9
                      ? "red"
                      : "rgb(80,72,229)",
                marginLeft: 7,
              }}
            >
              <Typography
                style={{ fontWeight: "bold" }}
                fontSize={11}
                color="white"
              >
                {callUpdate.callResultStr || "İşlemde"}
                {callUpdate.callSummary?.durationInSeconds != undefined
                  ? " " +
                    secondsToString(callUpdate.callSummary.durationInSeconds)
                  : ""}
              </Typography>
            </div>
          )}
          {callUpdate && (
            <a
              style={{ marginLeft: 5 }}
              href="#"
              onClick={() => {
                window.open(
                  "../transcript/" + callUpdate._id,
                  "popup",
                  "width=400,height=600",
                );
              }}
            >
              Transkript
            </a>
          )}
          <Typography style={{ marginLeft: 5 }}>
            {new Date(this.props.history.d).toLocaleString("tr-TR")}
          </Typography>
        </div>

        {/* {callUpdate != undefined && callUpdate.callSummary && <div style={{display:"flex", flex:1}}>
                
                <Typography>{callUpdate.callSummary.summary} sss</Typography>    
                
            </div>} */}
      </div>
    );
  }
}

var labelChecks = [
  (history, order) => {
    if (history.data && history.data._p && history.status == 1) {
      var id = 0;

      for (var i = 0; i < order.history.length; i++) {
        if (
          order.history[i].status == 1 &&
          order.history[i].data &&
          order.history[i].data._p
        ) {
          if (order.history[i] == history) break;
          id++;
        }
      }

      return {
        label:
          "Sürücü Atandı" +
          (history.data.workerId != undefined
            ? " (" +
              global.cache.workers.find((s) => s._id == history.data.workerId)
                ?.name +
              ")"
            : ""),
        p: "../messages/" + order._id + "/" + id,
        link: "../driver/" + history.data._p,
        customElement: (
          <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
            <a href={"../driver/" + history.data._p}>
              <Typography>{order.driverNames[history.data._p]}</Typography>
            </a>
            <a
              href="#"
              onClick={(e) => {
                window.open(
                  "../messages/" + order._id + "/" + id,
                  "popup",
                  "width=400,height=600",
                );
                e.preventDefault();
              }}
            >
              <Typography>Mesajları Gör</Typography>
            </a>
            <div
              style={{
                borderRadius: 10,
                padding: 8,
                paddingTop: 2,
                paddingBottom: 2,
                width: "fit-content",
                backgroundColor:
                  history.data.messageCount > 0 ? "green" : "red",
                alignItems: "center",
                justifyContent: "center",
                height: "fit-content",
              }}
            >
              <Typography
                style={{ fontWeight: "bold" }}
                fontSize={11}
                color="white"
              >
                {history.data.messageCount} Mesaj
              </Typography>
            </div>
            <Typography>
              {new Date(history.d).toLocaleString("tr-TR")}
            </Typography>
          </div>
        ),
        linkname: order.driverNames[history.data._p],
      };
    }

    return undefined;
  },
  (history, order) => {
    if (history.data && history.data._p && history.status == 0) {
      const foundUpdate = order.updates.find(
        (s) => s.driverId == history.data._p && s.type == 1,
      );

      return {
        label:
          "Sürücü İptali" +
          (history.data.worker != undefined
            ? history.data.worker.startsWith("000000")
              ? " (Müşteri Tarafından)"
              : " (" +
                global.cache.workers.find((s) => s._id == history.data.worker)
                  ?.name +
                ")"
            : ""),
        alt: foundUpdate ? (
          <div
            style={{
              borderRadius: 10,
              padding: 8,
              paddingTop: 2,
              paddingBottom: 2,
              backgroundColor: "red",
              marginLeft: 7,
              width: "fit-content",
              height: "fit-content",
            }}
          >
            <Typography
              style={{ fontWeight: "bold" }}
              fontSize={11}
              color="white"
            >
              {orderCancelReasons[foundUpdate.reason]}
            </Typography>
          </div>
        ) : undefined,
        link: "../driver/" + history.data._p,
        linkname: order.driverNames[history.data._p],
      };
    }

    return undefined;
  },
  (history, order) => {
    if (history.data && history.data.changes) {
      return {
        label: history.data.message,
        altComponent: (
          <div style={{ marginTop: 10 }}>
            {Array.isArray(history.data.changes) &&
              history.data.changes.map((change, index) => {
                const isDateField = change.field === "date";

                const beforeValue = isDateField
                  ? API.formatDateTR(change.before)
                  : API.formatText(change.before);

                const afterValue = isDateField
                  ? API.formatDateTR(change.after)
                  : API.formatText(change.after);

                return (
                  <Typography
                    key={index}
                    variant="body2"
                    style={{ marginTop: 6, marginLeft: 12 }}
                  >
                    <strong>{API.humanizeField(change.field)}</strong>:{" "}
                    <span style={{ color: "#888" }}>{beforeValue}</span> →{" "}
                    <span style={{ color: "#1976d2", fontWeight: 500 }}>
                      {afterValue}
                    </span>
                  </Typography>
                );
              })}
          </div>
        ),
      };
    } else if (history.data && history.data.message) {
      return {
        label: "Operatör değiştirildi:",
        altComponent: (
          <Typography style={{ marginTop: 10 }}>
            {history.data.message}
          </Typography>
        ),
      };
    }

    return undefined;
  },
  (history) => {
    if (history.data && history.status == -1)
      return { label: "Müşteri İptali" };

    return undefined;
  },
  (history) => {
    if (history.data && !history.status && history.data == 2)
      return { label: "Sürücü Yola Çıktı" };

    return undefined;
  },
  (history) => {
    if (
      history.data &&
      !history.status &&
      history.data.currentWaypoint != undefined
    )
      return {
        label: history.data.nearLocation ? "Sürücü Yakın" : "Sürücü Vardı",
      };

    return undefined;
  },
  (history) => {
    if (history.data && history.data.pictureSent)
      return {
        label: "Fotoğraf Yüklendi",
        link:
          "https://tasimacim-order-pictures.s3.eu-central-1.amazonaws.com/" +
          history.data.pictureSent,
        linkname: "Gör",
      };

    return undefined;
  },
  (history, order) => {
    if (history.data && history.data.call)
      return {
        label: (history.data.p ? "Sürücü" : "Müşteri") + " Araması",
        altComponent: getAltComponentSummary(order, history),
        customElement: <Recording order={order} history={history} />,
        link:
          "https://oim.verimor.com.tr/switch/reports/cdrs/" + history.data.call,
        linkname: "Dinle",
      };
  },
  (history) => {
    if (history.status == 3) return { label: "Tarih Kesinleş." };

    return undefined;
  },
  (history) => {
    if (history.data && history.data.payment && history.status == undefined)
      return { label: "Ödeme Yapıldı" };

    return undefined;
  },
  (history) => {
    if (history.data && history.data.description)
      return {
        label: "Yetkili Gelişme (" + history.data.workerName + ")",
        altComponent: (
          <Typography style={{ marginTop: 10 }}>
            {history.data.description}
          </Typography>
        ),
      };

    return undefined;
  },
  (history) => {
    if (history.data.notificationId)
      return {
        label:
          "Bildirim" +
          (history.data.workerId.startsWith("00000")
            ? " (SİSTEM)"
            : history.data.workerId != undefined
              ? " (" +
                global.cache.workers.find((s) => s._id == history.data.workerId)
                  ?.name +
                ")"
              : ""),
        linkname: "Bildirime Git",
        link: "../notification/" + history.data.notificationId,
      };

    return undefined;
  },
];

function getAltComponentSummary(order, history) {
  var callUpdate = order.updates?.find((s) => s.callId == history.data.call);

  if (callUpdate != undefined && callUpdate.callSummary != undefined) {
    return (
      <div style={{ display: "flex", flex: 1, marginTop: 10 }}>
        <Typography>{callUpdate.callSummary.summary}</Typography>
      </div>
    );
  }

  return undefined;
}

function getOrderLogValue(history, order) {
  for (var i = 0; i < labelChecks.length; i++) {
    var value = labelChecks[i](history, order);
    if (value) {
      return {
        ...value,
        date: history.d,
        isOperatorAssignment: value.label === "Operatör değiştirildi:",
      };
    }
  }

  return undefined;
}

const options = ["Test", "another test"];
var ADDITIONALS = [
  "Ön koltukta refakat",
  "Evcil hayvanım var",
  "Üstü kapalı kamyonet",
  "Sürücünün yardımı",
  "Yardımcı",
  "Montaj/Demontaj",
  "Paketleme",
];
export default class OrderScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      editing: false,
      saving: false,
      notificationTemplatesDropdownOpen: false,
      notificationCenter: {
        title: {},
        body: {},
        receiverType: 0,
        receiverName: "",
        receiverId: "",
      },
      notificationCenterModalOpen: false,
      approveDriverDialog: false,
      backdropVisible: false,
      actionsDropdownOpen: false,
      assignDriverModalOpen: false,
      addHistoryUpdateModalOpen: false,
      addHistoryUpdateText: "",
      sendPaymentLinkModalOpen: false,
      sendPaymentLinkPhoneNumber: "",
      invoiceApprovalDialogOpen: false,
      pendingInvoiceType: undefined,
      approvingInvoice: false,
      operatorHistoryExpanded: false,
      manageOrderRequests: undefined,
      manageOrderHistory: undefined,
      manageOrderLoading: false,
      manageOrderExpanded: true,
      manageOrderOpenItems: {},
    };

    var id = props.match.params.id;

    if (!id) props.history.goBack();
  }

  handleClick() {
    console.info(`You clicked ${options[0]}`);
  }

  handleMenuItemClick(event, index) {
    setSelectedIndex(index);
    this.setState({ actionsDropdownOpen: false });
  }

  handleToggle() {
    this.setState({ actionsDropdownOpen: !this.state.actionsDropdownOpen });
  }

  handleClose(event) {
    if (
      this.anchorRef.current &&
      this.anchorRef.current.contains(event.target)
    ) {
      return;
    }

    this.setState({ actionsDropdownOpen: false });
  }

  componentDidMount() {
    this.loadOrderDetails();
    this.loadManageOrderData();

    // API.fetch('getapplications').then((e) => {
    //     if(!e.error) this.setState({applications: e});
    // })
  }

  loadOrderDetails = async () => {
    const id = this.props.match.params.id;
    const response = await API.fetch("getorder", { _id: id });

    if (response.error) {
      if (!this.state.order) this.props.history.goBack();
      return response;
    }

    this.polyLine =
      response.locations != null && response.locations.length > 0
        ? response.locations.map((s) => [s.l[1], s.l[0]])
        : undefined;

    var arr = [];

    arr.push([response.from.coordinates[1], response.from.coordinates[0]]);
    response.waypoints.forEach((waypoint) =>
      arr.push([waypoint.coordinates[1], waypoint.coordinates[0]]),
    );
    arr.push([response.to.coordinates[1], response.to.coordinates[0]]);

    if (
      (response.status == 2 || response.status == 10) &&
      response.locations != undefined &&
      response.locations.length > 0
    ) {
      arr.push([
        response.locations[response.locations.length - 1].l[1],
        response.locations[response.locations.length - 1].l[0],
      ]);
    } else if (response.driverLastLocation) {
      arr.push([
        response.driverLastLocation.coordinates[1],
        response.driverLastLocation.coordinates[0],
      ]);
    }

    this.mapBounds = arr;

    this.setState({ order: response, loading: false });
    return response;
  };

  loadManageOrderData = async () => {
    const id = this.props.match.params.id;

    this.setState({ manageOrderLoading: true });

    try {
      const [requestsResponse, historyResponse] = await Promise.all([
        API.getManageOrderRequests({ _id: id }),
        API.getManageOrderHistory({ _id: id }),
      ]);

      this.setState({
        manageOrderRequests: requestsResponse?.error
          ? { orderId: id, requests: [], extraCharges: [], summary: {} }
          : requestsResponse,
        manageOrderHistory: historyResponse?.error
          ? { orderId: id, history: [] }
          : historyResponse,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ manageOrderLoading: false });
    }
  };

  toggleManageOrderPanel = () => {
    this.setState((prevState) => ({
      manageOrderExpanded: !prevState.manageOrderExpanded,
    }));
  };

  toggleManageOrderItem = (key) => {
    this.setState((prevState) => ({
      manageOrderOpenItems: {
        ...prevState.manageOrderOpenItems,
        [key]: !prevState.manageOrderOpenItems[key],
      },
    }));
  };

  getSelectedInvoiceType = () => {
    const invoiceType = this.state.order?.invoiceDetails?.invoiceType;
    return ORDER_INVOICE_TYPE_OPTIONS.includes(invoiceType)
      ? invoiceType
      : undefined;
  };

  openInvoiceApprovalDialog = () => {
    this.setState({
      invoiceApprovalDialogOpen: true,
      pendingInvoiceType: this.getSelectedInvoiceType(),
    });
  };

  closeInvoiceApprovalDialog = () => {
    if (this.state.approvingInvoice) return;
    this.setState({ invoiceApprovalDialogOpen: false });
  };

  getDisplayedDriverPosition = (order = this.state.order) => {
    if (!order) return undefined;

    if (
      order.locations != undefined &&
      order.locations.length > 0 &&
      (order.status == 2 || order.status == 10)
    ) {
      const lastLocation = order.locations[order.locations.length - 1];
      return {
        coordinates: lastLocation.l,
        time: lastLocation.time,
      };
    }

    if (order.status != 2 && order.status != 10 && order.status != -1) {
      return order.driverLastLocation;
    }

    return undefined;
  };

  approveInvoice = () => {
    const invoiceType = this.state.pendingInvoiceType;
    if (!ORDER_INVOICE_TYPE_OPTIONS.includes(invoiceType)) return;

    this.setState({ approvingInvoice: true });

    API.fetch("approveinvoice", {
      id: this.state.order._id,
      invoiceType,
    }).then((approveResponse) => {
      if (approveResponse?.error) {
        this.setState({ approvingInvoice: false });
        alert(approveResponse.error);
        return;
      }

      this.setState({
        approvingInvoice: false,
        invoiceApprovalDialogOpen: false,
      });
      location.reload();
    });
  };

  render() {
    console.log(this.state?.order?.isConsentToShareDetails);
    IN_EDIT_MODE = this.state.editing;

    if (this.state.loading) return <></>;

    const selectedInvoiceType = this.getSelectedInvoiceType();
    const canOpenInvoiceApproval =
      this.state.order?.invoiceDetails?.status != 10 &&
      this.state.order?.invoiceDetails?.invoiceUrl != undefined;
    const displayedDriverPosition = this.getDisplayedDriverPosition(
      this.state.order,
    );
    const driverMarkerPosition = Array.isArray(
      displayedDriverPosition?.coordinates,
    )
      ? displayedDriverPosition.coordinates
      : undefined;
    const driverPickupDistance = calculateDistanceInKm(
      driverMarkerPosition,
      this.state.order?.from?.coordinates,
    );
    const driverPickupEta = formatEstimatedPickupEta(driverPickupDistance);
    const driverMapIcon = getDriverMapIcon(this.state.order?.vehicle);

    var timeMinutes = this.state.order.time * 60000;

    var time =
      convertMillisToTimeString(timeMinutes) +
      " (" +
      convertMillisToTimeString(
        VEHICLE_TIMES[this.state.order.vehicle] *
          (2 + this.state.order.waypoints.length) *
          60000,
      ) +
      " yükleme boşaltma)";

    var baseFee = parseFloat(this.state.order.pricing.price);
    baseFee -= this.state.order.pricing.commision;
    this.state.order.pricing.bridges.forEach((s) => (baseFee -= s.price));
    for (var i = 0; i < this.state.order.additionals.length; i++) {
      if (this.state.order.additionals[i])
        baseFee -= this.state.order.additionalPrices[i] * 0.85;
    }

    var timePassed = "";
    if (this.state.order.status > 1 && this.state.order.status != 3) {
      for (var i = this.state.order.updates.length - 1; i >= 0; i--) {
        const update = this.state.order.updates[i];

        if (update.type == 9 && update.waypoint == 0) {
          var referenceEndTime = Date.now();

          if (this.state.order.status == 10) {
            var closeUpdate = this.state.order.updates.find(
              (s) => s.type == 10 && s.isPickup == false,
            );
            if (closeUpdate)
              referenceEndTime =
                parseInt(closeUpdate._id.substring(0, 8), 16) * 1000;
          }

          var millisecondsPassed =
            referenceEndTime - parseInt(update._id.substring(0, 8), 16) * 1000;
          timePassed = convertMillisToTimeString(millisecondsPassed);

          if (this.state.order.vehicle != 6) {
            var timeDifference =
              this.state.order.time * 60000 - millisecondsPassed;

            if (timeDifference >= 0) {
              timePassed +=
                " (Servis süresi aşımına " +
                convertMillisToTimeString(timeDifference) +
                ")";
            } else {
              timePassed +=
                " (Servis süresinden " +
                convertMillisToTimeString(-timeDifference) +
                " fazla)";
            }
          }

          break;
        }
      }
    }

    var lastLocationUpdateDate = undefined;
    if (
      (this.state.order.status == 2 || this.state.order.status == 10) &&
      this.state.order.locations != undefined &&
      this.state.order.locations.length > 0
    ) {
      lastLocationUpdateDate = new Date(
        this.state.order.locations[this.state.order.locations.length - 1].time,
      );
    } else if (this.state.order.driverLastLocation) {
      lastLocationUpdateDate = new Date(
        this.state.order.driverLastLocation.time,
      );
    }

    const orderLogValues = this.state.order.history
      .map((history) => getOrderLogValue(history, this.state.order))
      .filter(Boolean);
    const operatorAssignmentLogs = orderLogValues.filter(
      (log) => log.isOperatorAssignment,
    );
    const otherOrderLogs = orderLogValues.filter(
      (log) => !log.isOperatorAssignment,
    );
    const manageOrderRequestsResponse = this.state.manageOrderRequests || {};
    const manageOrderHistoryResponse = this.state.manageOrderHistory || {};
    const manageOrderRequests = Array.isArray(
      manageOrderRequestsResponse.requests,
    )
      ? manageOrderRequestsResponse.requests
      : [];
    const manageOrderExtraCharges = Array.isArray(
      manageOrderRequestsResponse.extraCharges,
    )
      ? manageOrderRequestsResponse.extraCharges
      : [];
    const manageOrderHistoryEntries = Array.isArray(
      manageOrderHistoryResponse.history,
    )
      ? manageOrderHistoryResponse.history
      : [];
    const manageOrderFeedItems = manageOrderRequests
      .map(buildManageOrderFeedItem)
      .filter(Boolean)
      .sort((a, b) => (b?.time || 0) - (a?.time || 0));
    const showManageOrderSection = Boolean(
      this.state.order?.manageOrder ||
        this.state.manageOrderLoading ||
        manageOrderFeedItems.length > 0 ||
        manageOrderExtraCharges.length > 0 ||
        manageOrderHistoryEntries.length > 0,
    );
    const viewportWidth =
      typeof window !== "undefined" ? window.innerWidth : 1440;
    const isCompactLayout = viewportWidth < 1120;
    const isMobileLayout = viewportWidth < 768;
    const orderDisplayId = this.state.order._id
      .toString()
      .substring(18)
      .toUpperCase();
    const placedAt = new Date(
      parseInt(this.state.order._id.substring(0, 8), 16) * 1000,
    );
    const incidentSummary = getOrderIncidentSummary(this.state.order);
    const leftColumnStyle = isCompactLayout ? {} : { gridColumn: 1 };
    const rightColumnStyle = isCompactLayout ? {} : { gridColumn: 2 };
    const timelineEntries = [...otherOrderLogs, ...operatorAssignmentLogs]
      .sort((a, b) => (b?.date || 0) - (a?.date || 0))
      .slice(0, 8);

    return (
      <div
        style={{
          display: "block",
          width: "100%",
          backgroundColor: "#F8FAFC",
          paddingBottom: 32,
        }}
      >
        <div
          style={{
            width: "100%",
            padding: isMobileLayout ? "0 12px" : "0 16px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              marginTop: isMobileLayout ? 20 : 32,
              marginBottom: 24,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <div style={{ display: "flex", flex: 1, minWidth: isMobileLayout ? 0 : 280 }}>
              <div>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: "#64748B",
                    marginBottom: 8,
                  }}
                >
                  Sipariş ID
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: isMobileLayout ? 30 : 42,
                      lineHeight: 1,
                      fontWeight: 700,
                      letterSpacing: "-0.03em",
                      color: "#0B1C30",
                    }}
                  >
                    #{orderDisplayId}
                  </Typography>
                  <BusinessBadge
                    business={this.state.order.business}
                    imageHeight={28}
                    imageWidth={56}
                    textStyle={{ fontSize: 18 }}
                  />
                  <div
                    style={{
                      backgroundColor: incidentSummary.badgeBackground,
                      color: incidentSummary.badgeColor,
                      padding: "8px 14px",
                      borderRadius: 4,
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    {incidentSummary.badge}
                  </div>
                </div>
                <Typography
                  style={{
                    marginTop: 10,
                    color: "#475467",
                    fontSize: isMobileLayout ? 14 : 15,
                  }}
                >
                  Oluşturulma: {placedAt.toLocaleDateString("tr-TR")}
                </Typography>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
                width: isMobileLayout ? "100%" : "auto",
              }}
            >
              {this.state.editing && (
                <Button
                  onClick={() => {
                    this.setState({ editing: false, order: this.orderOld });
                  }}
                  style={{
                    borderColor: "#C7C4D8",
                    color: "#0B1C30",
                    paddingLeft: 18,
                    paddingRight: 18,
                    minHeight: 44,
                    width: isMobileLayout ? "100%" : "auto",
                  }}
                  color="error"
                  variant="outlined"
                >
                  İptal
                </Button>
              )}

              {!this.state.editing && (
                <Button
                  onClick={() => {
                    this.orderOld = JSON.parse(
                      JSON.stringify(this.state.order),
                    );
                    this.setState({ editing: true });
                  }}
                  style={{
                    borderColor: "#C7C4D8",
                    color: "#0B1C30",
                    paddingLeft: 18,
                    paddingRight: 18,
                    minHeight: 44,
                    width: isMobileLayout ? "100%" : "auto",
                  }}
                  variant="outlined"
                >
                  Detayları Düzenle
                  <EditIcon
                    sx={{ width: 18, height: 18 }}
                    style={{ marginLeft: 10 }}
                  />
                </Button>
              )}

              <ButtonGroup
                variant="contained"
                ref={(a) => (this.anchorRef = a)}
                aria-label="split button"
                style={{ boxShadow: "none", width: isMobileLayout ? "100%" : "auto" }}
              >
                <Button
                  size="small"
                  aria-controls={
                    this.state.actionsDropdownOpen
                      ? "split-button-menu"
                      : undefined
                  }
                  aria-expanded={
                    this.state.actionsDropdownOpen ? "true" : undefined
                  }
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={() => this.handleToggle()}
                  style={{
                    minHeight: 44,
                    backgroundColor: "#3525CD",
                    paddingLeft: 18,
                    paddingRight: 18,
                    borderRadius: 8,
                    width: isMobileLayout ? "100%" : "auto",
                  }}
                >
                  İşlemler <ArrowDropDownIcon style={{ marginLeft: 8 }} />
                </Button>
              </ButtonGroup>
              <Popper
                sx={{
                  zIndex: 1,
                }}
                open={this.state.actionsDropdownOpen}
                anchorEl={this.anchorRef}
                role={undefined}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center bottom",
                    }}
                  >
                    <Paper>
                      <ClickAwayListener
                        onClickAway={(e) => this.handleClose(e)}
                      >
                        <MenuList id="split-button-menu" autoFocusItem>
                          {this.state.order.status != -1 &&
                            this.state.order.status != 10 && (
                              <MenuItem
                                onClick={() => {
                                  this.handleClose();
                                  global.openPrompt(
                                    "Siparişi iptal et?",
                                    "Siparişi iptal etmek istediğinizden emin misiniz?",
                                    "Onayla",
                                    () => {
                                      this.setState({ backdropVisible: true });

                                      API.fetch("cancelorder", {
                                        _id: this.state.order._id,
                                      }).then((e) => {
                                        if (!e.error) {
                                          this.state.order.status = -1;
                                          delete this.state.order.driver;
                                        }

                                        this.setState({
                                          backdropVisible: false,
                                        });
                                      });
                                    },
                                  );
                                }}
                              >
                                Siparişi iptal et
                              </MenuItem>
                            )}

                          {this.state.order.status != -1 &&
                            this.state.order.status != 10 &&
                            this.state.order.paymentMethod == 5 &&
                            this.state.order.payment == undefined && (
                              <MenuItem
                                onClick={() => {
                                  this.handleClose();
                                  global.openPrompt(
                                    "Nakite çevir?",
                                    "Siparişin ödemesini nakite çevirmek istediğinize emin misiniz?",
                                    "Onayla",
                                    () => {
                                      this.setState({ backdropVisible: true });

                                      API.fetch("changepaymentmethod", {
                                        _id: this.state.order._id,
                                      }).then((e) => {
                                        location.reload();
                                      });
                                    },
                                  );
                                }}
                              >
                                Nakite çevir
                              </MenuItem>
                            )}

                          {(this.state.order.status == 2 ||
                            this.state.order.status == 3) && (
                            <MenuItem
                              onClick={() => {
                                this.handleClose();
                                global.openPrompt(
                                  "Planlanmışa çevir?",
                                  "Siparişi planlanmışa çevirmek istediğinizden emin misiniz?",
                                  "Onayla",
                                  () => {
                                    this.setState({ backdropVisible: true });

                                    API.fetch("setorderstatus", {
                                      _id: this.state.order._id,
                                    }).then((e) => {
                                      if (!e.error) {
                                        this.state.order.status = 1;
                                        delete this.state.order.currentWaypoint;
                                      }

                                      this.setState({ backdropVisible: false });
                                    });
                                  },
                                );
                              }}
                            >
                              Planlanmışa çevir
                            </MenuItem>
                          )}

                          {this.state.order.status >= 1 &&
                            this.state.order.status < 10 && (
                              <MenuItem
                                onClick={() => {
                                  this.handleClose();
                                  global.openPrompt(
                                    "Sürücü iptali?",
                                    "Sürücü iptali yapmak istediğinizden emin misiniz?",
                                    "Onayla",
                                    () => {
                                      this.setState({ backdropVisible: true });

                                      API.fetch("releaseorder", {
                                        _id: this.state.order._id,
                                      }).then((e) => {
                                        if (!e.error) {
                                          this.state.order.status = 0;
                                          delete this.state.order.driver;
                                        }

                                        this.setState({
                                          backdropVisible: false,
                                        });
                                      });
                                    },
                                  );
                                }}
                              >
                                Sürücü iptali
                              </MenuItem>
                            )}

                          {this.state.order.status >= 0 &&
                            this.state.order.status < 10 && (
                              <MenuItem
                                onClick={() => {
                                  this.setState({
                                    assignDriverModalOpen: true,
                                  });
                                  this.handleClose();
                                }}
                              >
                                Sürücü ata
                              </MenuItem>
                            )}

                          {this.state.order.status >= 2 &&
                            this.state.order.status < 10 &&
                            this.state.order.paymentMethod == 5 &&
                            this.state.order.code == undefined && (
                              <MenuItem
                                onClick={() => {
                                  this.setState({
                                    sendPaymentLinkModalOpen: true,
                                  });
                                  this.handleClose();
                                }}
                              >
                                Ödeme Linki Gönder
                              </MenuItem>
                            )}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isCompactLayout
                ? "1fr"
                : "minmax(0, 2.35fr) minmax(360px, 0.95fr)",
              gap: isMobileLayout ? 16 : 24,
              alignItems: "start",
              width: "100%",
            }}
          >
            <div style={{ minWidth: 0 }}>

          {/* <div style={{display:"flex",marginTop:24}}>
                    <LogisticAnalytic backgroundColor={'rgba(80,72,229,.1)'} first title={"Son 7 günde sipariş"} value={this.state.driver.orders.length} icon={<LocalShippingIcon sx={{color: 'rgb(80,72,229)'}} />} />
                    <LogisticAnalytic backgroundColor={"rgba(134,197,82,.1)"} title={"Güncel bakiye"} value={(this.state.driver.credits+this.state.driver.freeCredits) +(this.state.driver.freeCredits > 0?" ("+this.state.driver.credits+")":"")} icon={<AccountBalanceWalletIcon sx={{color: 'rgb(134,197,82)'}} />} />
                    <LogisticAnalytic backgroundColor={"rgba(255,176,32,.1)"} title={"7 günde iptal"} value={(this.state.driver.canceledOrderCount)} icon={<ErrorIcon sx={{color: 'rgb(255,176,32)'}} />} />
                
                    
                </div> */}

          <Badge
            style={{
              marginTop: 8,
              padding: 0,
              ...leftColumnStyle,
            }}
          >
            <div style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: isMobileLayout ? "18px 18px 14px 18px" : "24px 28px 18px 28px",
                  borderBottom: "1px solid #E7EDF6",
                  gap: 16,
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <Typography
                    style={{
                      color: "#64748B",
                      fontSize: 12,
                      fontWeight: 700,
                      letterSpacing: "0.14em",
                      textTransform: "uppercase",
                      marginBottom: 10,
                    }}
                  >
                    Genel Bakış
                  </Typography>
                  <Typography
                    style={{
                      fontSize: isMobileLayout ? 24 : 28,
                      lineHeight: 1.1,
                      fontWeight: 700,
                      color: "#0F172A",
                      letterSpacing: "-0.03em",
                    }}
                  >
                    Sipariş Özeti
                  </Typography>
                  <Typography
                    style={{
                      marginTop: 10,
                      color: "#64748B",
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}
                  >
                    Müşteri, araç, durum ve operasyon detaylarını bölüm bölüm inceleyin.
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <BusinessBadge
                    business={this.state.order.business}
                    imageHeight={28}
                    imageWidth={56}
                    textStyle={{ fontSize: 18 }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isCompactLayout
                    ? "1fr"
                    : "repeat(3, minmax(0, 1fr))",
                  gap: isMobileLayout ? 16 : 24,
                  padding: isMobileLayout ? "18px 18px 8px 18px" : "22px 28px 8px 28px",
                }}
              >
                <EnterpriseSummaryBlock
                  label="Müşteri"
                  title={this.state.order.client.name}
                  subtitle={this.state.order.client.email || "-"}
                />
                <EnterpriseSummaryBlock
                  label="Atanan Araç"
                  title={VEHICLE_NAMES[this.state.order.vehicle] || "-"}
                  subtitle={this.state.order.driverName || "Sürücü atanmadı"}
                />
                <EnterpriseSummaryBlock
                  label="Olay Durumu"
                  title={incidentSummary.title}
                  subtitle={incidentSummary.subtitle}
                  titleColor={incidentSummary.tone}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isCompactLayout
                    ? "1fr"
                    : "repeat(2, minmax(0, 1fr))",
                  gap: 16,
                  padding: isMobileLayout ? "0 18px 18px 18px" : "0 28px 28px 28px",
                }}
              >
                <EnterpriseDetailSection label="Operasyon">
                  <DetailText
                    editable={false}
                    link={"../client/" + this.state.order.clientId}
                    first
                    label={"Müşteri"}
                    value={
                      this.state.order.client.name +
                      (this.state.order.business
                        ? ` (${this.state.order.business.name}) `
                        : "") +
                      " " +
                      API.getPlatformEmoji(this.state.order.platform)
                    }
                  />

                  <DetailText centerLabel editable={false} label={"Bakan Yetkili"}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center",
                      }}
                    >
                      <Typography>
                        {this.state.order.assignedWorker == undefined
                          ? "Bakan bir yetkili yok"
                          : this.state.order.assignedWorker.name}
                      </Typography>
                      {this.state.order.assignedWorker?.name != API.user.name && (
                        <Button
                          size="small"
                          onClick={() => {
                            global.openPrompt(
                              "Sipariş üstüne almak istediğinden emin misin?",
                              "",
                              "Onayla",
                              () => {
                                global.showLoadingPanel();

                                API.fetch("assignworker", {
                                  _id: this.state.order._id,
                                  oldWorker:
                                    this.state.order.assignedWorker != undefined
                                      ? this.state.order.assignedWorker._id
                                      : undefined,
                                }).then((e) => {
                                  global.hideLoadingPanel();

                                  if (e.error) {
                                    global.showPopup("Hata", e.error);
                                  } else {
                                    this.state.order.assignedWorker =
                                      e.assignedWorker;
                                    this.forceUpdate();
                                  }
                                });
                              },
                            );
                          }}
                        >
                          Üstüne Al
                        </Button>
                      )}
                    </div>
                  </DetailText>
                </EnterpriseDetailSection>

                <EnterpriseDetailSection label="Planlama ve Durum">
                  {this.state.order.vehicle != 6 && (
                    <>
                      <DetailText
                        editable={true}
                        customEdit={() => (
                          <LocalizationProvider
                            adapterLocale="tr"
                            dateAdapter={AdapterDayjs}
                          >
                            <DateTimePicker
                              ampm={false}
                              defaultValue={dayjs(this.state.order.date)}
                              onChange={(e) =>
                                (this.state.order.date = e.$d.getTime())
                              }
                            />
                          </LocalizationProvider>
                        )}
                        first
                        label={"Ayarlanmış Tarih"}
                        value={new Date(this.state.order.date).toLocaleString(
                          "tr-TR",
                        )}
                      />
                      <DetailText
                        editable={false}
                        label={"Araç"}
                        value={VEHICLE_NAMES[this.state.order.vehicle]}
                      />
                    </>
                  )}
                  {this.state.order.vehicle == 6 && (
                    <DetailText
                      editable={false}
                      first
                      label={"Araç"}
                      value={VEHICLE_NAMES[this.state.order.vehicle]}
                    />
                  )}
                  <DetailText
                    editable={false}
                    label={"Durum"}
                    value={
                      this.state.order.status == 1 && this.state.order.vehicle == 6
                        ? "Sürücü Bulundu"
                        : STATUS[this.state.order.status].t
                    }
                  />
                  {this.state.order.vehicle == 6 &&
                    this.state.order.scheduledStartDate != undefined && (
                      <DetailText
                        editable={false}
                        label={"Kesinleş. Tarih"}
                        value={
                          new Date(
                            this.state.order.scheduledStartDate,
                          ).toLocaleDateString("tr-TR") +
                          " " +
                          digit(
                            new Date(
                              this.state.order.scheduledStartDate,
                            ).getHours(),
                          ) +
                          ":" +
                          digit(
                            new Date(
                              this.state.order.scheduledStartDate,
                            ).getMinutes(),
                          ) +
                          "-" +
                          digit(
                            new Date(
                              this.state.order.scheduledEndDate,
                            ).getHours(),
                          ) +
                          ":" +
                          digit(
                            new Date(
                              this.state.order.scheduledEndDate,
                            ).getMinutes(),
                          )
                        }
                      />
                    )}
                  {this.state.order.code != undefined && (
                    <DetailText
                      editable={false}
                      label={"Teslim Kodu"}
                      value={this.state.order.code}
                    />
                  )}
                  {this.state.order.code == undefined &&
                    this.state.order.status != 10 &&
                    this.state.order.paymentMethod == 5 && (
                      <DetailText editable={false} label={"Teslim Kodu"}>
                        <Typography style={{ color: "crimson" }}>
                          Ödeme Yapılmamış
                        </Typography>
                      </DetailText>
                    )}
                  {this.state.order.status > 1 && this.state.order.status != 3 && (
                    <DetailText
                      editable={false}
                      label={"Geçen Servis Süresi"}
                      value={timePassed}
                    />
                  )}
                  <DetailText
                    label={"Not"}
                    onChange={(e) => {
                      this.state.order.note = e;
                      this.forceUpdate();
                    }}
                    value={this.state.order.note}
                  />
                </EnterpriseDetailSection>

                <EnterpriseDetailSection
                  label="Güzergah"
                  style={isCompactLayout ? undefined : { gridColumn: "1 / -1" }}
                >
                  <Waypoint
                    forceUpdate={() => this.forceUpdate()}
                    title={0}
                    waypoint={this.state.order.from}
                  />
                  {this.state.order.waypoints.map((x, i) => (
                    <Waypoint
                      forceUpdate={() => this.forceUpdate()}
                      key={i}
                      title={i + 1}
                      waypoint={x}
                    />
                  ))}
                  <Waypoint
                    forceUpdate={() => this.forceUpdate()}
                    title={this.state.order.waypoints.length + 1}
                    waypoint={this.state.order.to}
                  />
                </EnterpriseDetailSection>

                <EnterpriseDetailSection label="Sürücü ve İletişim">
                  {this.state.order.driver != undefined && (
                    <DetailText
                      editable={false}
                      first
                      label={"Sürücü"}
                      value={
                        <div
                          style={{ display: "flex", gap: 10, alignItems: "center" }}
                        >
                          <Link to={"../driver/" + this.state.order.driver}>
                            <Typography>{this.state.order.driverName}</Typography>
                          </Link>
                          <a
                            href="#"
                            style={{ fill: "#3c9cd7" }}
                            onClick={() => {
                              window.open(
                                "../livesupport/" +
                                  this.state.order.driver +
                                  "?alt=" +
                                  encodeURIComponent(
                                    JSON.stringify({
                                      text:
                                        "#" +
                                        this.state.order._id
                                          .substring(18)
                                          .toUpperCase() +
                                        " (" +
                                        this.state.order.client.name +
                                        ") Sipariş Hakkında",
                                      data: { orderId: this.state.order._id },
                                    }),
                                  ),
                                "popup",
                                "width=400,height=600",
                              );
                            }}
                          >
                            <ForumIcon htmlColor={"#3c9cd7"} />
                          </a>

                          <a
                            href="#"
                            style={{ fill: "#3c9cd7" }}
                            onClick={() => {
                              this.setState({
                                notificationCenter: {
                                  body: {},
                                  title: {},
                                  receiverType: 1,
                                  receiverName: this.state.order.driverName,
                                  receiverId: this.state.order.driver,
                                },
                                notificationCenterModalOpen: true,
                              });
                            }}
                          >
                            <NotificationsActiveIcon htmlColor={"#3c9cd7"} />
                          </a>
                        </div>
                      }
                    />
                  )}
                  {this.state.order.status > 0 && (
                    <DetailText
                      editable={false}
                      first={this.state.order.driver == undefined}
                      label={"Atanmış Numara"}
                      value={this.state.order.phone}
                    />
                  )}
                  <DetailText editable={false} label={"İrtibat Telefonu"}>
                    <Typography>{this.state.order.contactNo || "-"}</Typography>
                  </DetailText>
                </EnterpriseDetailSection>

                <EnterpriseDetailSection label="Sipariş Bilgileri">
                  <DetailText
                customEdit={() => (
                  <>
                    <Select
                      onChange={(a) => {
                        this.state.order.acquisitionType = a.target.value;
                        this.forceUpdate();
                      }}
                      value={this.state.order.acquisitionType || ""}
                    >
                      {Object.keys(AcqusitionTypes).map((val, indx) => (
                        <MenuItem key={indx} value={val}>
                          {AcqusitionTypes[val]}
                        </MenuItem>
                      ))}
                    </Select>

                    {this.state.order.acquisitionType == -1 && (
                      <TextField
                        onChange={(e) => {
                          this.state.order.acquisitionNote = e.target.value;
                          this.forceUpdate();
                        }}
                        sx={{
                          padding: 0,
                          "& .MuiOutlinedInput-input": {
                            paddingTop: "7px",
                            paddingBottom: "7px",
                            paddingLeft: "14px",
                            paddingRight: "14px",
                          },
                        }}
                        value={this.state.order.acquisitionNote || ""}
                      />
                    )}
                    {/* style={{position:"absolute",right:24, left:"20%", padding:0}}  */}
                  </>
                )}
                label={"Nereden Duydu?"}
                value={
                  this.state.order.acquisitionType
                    ? AcqusitionTypes[this.state.order.acquisitionType] +
                      (this.state.order.acquisitionType == -1
                        ? " " + (this.state.order.acquisitionNote || "")
                        : "")
                    : ""
                }
              />
                  <DetailText editable={false} label={"Self Servis"}>
                    <Typography>
                      {this.state.order.self ? "Evet" : "Hayır"}
                    </Typography>
                  </DetailText>
                  <DetailText
                    editable={false}
                    label={"Mesafe"}
                    value={formatOrderDistance(this.state.order.distance)}
                  />
                  <DetailText editable={false} label={"Sipariş Türü"}>
                    <Typography>
                      {ORDER_TYPE_LABELS[this.state?.order?.orderType] || "-"}
                    </Typography>
                  </DetailText>
                  <DetailText editable={false} label={"Bilgi paylaşım onayı"}>
                    <Typography>
                      {this.state?.order?.isConsentToShareDetails
                        ? "Evet"
                        : "Hayır"}
                    </Typography>
                  </DetailText>
                </EnterpriseDetailSection>
              </div>
            </div>
          </Badge>

          {this.state.order.invoiceDetails != undefined && (
            <Badge style={{ marginTop: 24, padding: 0, ...leftColumnStyle }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 24,
                }}
              >
                <Typography style={{}} variant="h6">
                  Fatura Talebi
                </Typography>

                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {this.state.order.invoiceDetails?.status == 10 && (
                    <div
                      style={{
                        color: "white",
                        backgroundColor: "green",
                        fontWeight: "bold",
                        padding: 5,
                        paddingLeft: 12,
                        paddingRight: 12,
                        borderRadius: 100,
                      }}
                    >
                      <Typography fontWeight={"bold"}>
                        Fatura Onaylandı
                      </Typography>
                    </div>
                  )}
                  {this.state.order.invoiceDetails.invoiceUrl == undefined && (
                    <div
                      style={{
                        color: "white",
                        backgroundColor: "crimson",
                        fontWeight: "bold",
                        padding: 5,
                        paddingLeft: 12,
                        paddingRight: 12,
                        borderRadius: 100,
                      }}
                    >
                      <Typography fontWeight={"bold"}>
                        Fatura Yüklenmedi
                      </Typography>
                    </div>
                  )}
                  {this.state.order.invoiceDetails.invoiceUrl != undefined &&
                    this.state.order.invoiceDetails.status != 10 && (
                      <div
                        style={{
                          color: "white",
                          backgroundColor: "crimson",
                          fontWeight: "bold",
                          padding: 5,
                          paddingLeft: 12,
                          paddingRight: 12,
                          borderRadius: 100,
                        }}
                      >
                        <Typography fontWeight={"bold"}>
                          ONAY BEKLIYOR
                        </Typography>
                      </div>
                    )}
                  {this.state.order.invoiceDetails?.status == 1 && (
                    <Button
                      variant="contained"
                      component="label"
                      color="success"
                      disabled={!canOpenInvoiceApproval}
                      onClick={() => {
                        if (!canOpenInvoiceApproval) return;
                        this.openInvoiceApprovalDialog();
                      }}
                    >
                      Onayla
                    </Button>
                  )}

                  {this.state.order.invoiceDetails?.status != 10 && (
                    <Button variant="contained" component="label">
                      Fatura Yükle
                      <input
                        type="file"
                        hidden
                        onChange={async (e) => {
                          global.showLoadingPanel();
                          const ff = e.target.files[0];

                          let formData = new FormData();
                          formData.append("file", ff);
                          formData.append("id", this.state.order._id);

                          API.sendFile("uploadinvoice", formData).then(
                            (res) => {
                              if (res.error) alert(res.error);
                              else {
                                location.reload();
                              }
                            },
                          );

                          // API.fetch('uploadinvoice', {file: ff.name,id: this.state.order._id}).then(async e => {

                          //     if(!e.url) return;

                          //     let formData = new FormData()
                          //     formData.append('file', ff);

                          //     const response = await fetch(e.url, {method: "PUT",body:ff,headers: {
                          //             "Content-Type":"multipart/form-data"
                          //     }});

                          //     //console.log(response);
                          //    location.reload();
                          //     //global.hideLoadingPanel();
                          // })
                        }}
                      />
                    </Button>
                  )}
                </div>
              </div>

              {this.state.order.invoiceDetails.invoiceUrl != undefined && (
                <InvoicePreview url={this.state.order.invoiceDetails.invoiceUrl} />
              )}

              <div style={{ paddingLeft: 24, paddingBottom: 24 }}>
                <Typography>
                  Fatura Tipi:{" "}
                  {ORDER_INVOICE_TYPE_LABELS[selectedInvoiceType] || "-"}
                  <br />
                  {this.state.order.invoiceDetails.toTasimacim == true && (
                    <>
                      Kurumsal Detaylar:
                      <br />
                      TAŞIMACIM YAZILIM TEKNOLOJİLERİ ANONİM ŞİRKETİ
                      <br />
                      KAVACIK MAH. FATİH SULTAN MEHMET CAD. TONOGLU NO: 3 İÇ
                      KAPI NO: 4 BEYKOZ/ İSTANBUL
                      <br />
                      Vergi Dairesi: Beykoz
                      <br />
                      VKN: 8281080316
                      <br />
                    </>
                  )}
                  {this.state.order.invoiceDetails.toTasimacim != true &&
                    this.state.order.invoiceDetails.isBusiness == true && (
                      <>
                        Kurumsal Detaylar:
                        <br />
                        {this.state.order.invoiceDetails.businessName}
                        <br />
                        {this.state.order.invoiceDetails.address}
                        <br />
                        Vergi Dairesi:{" "}
                        {this.state.order.invoiceDetails.businessTaxDep}
                        <br />
                        VKN: {this.state.order.invoiceDetails.businessTaxNo}
                        <br />
                      </>
                    )}
                  {this.state.order.invoiceDetails.toTasimacim != true &&
                    this.state.order.invoiceDetails.isBusiness == false && (
                      <>
                        Bireysel Detaylar:
                        <br />
                        {this.state.order.invoiceDetails.individualName}{" "}
                        {this.state.order.invoiceDetails.individualSurname}
                        <br />
                        {this.state.order.invoiceDetails.address}
                        <br />
                        T.C. Kimlik Numarası:{" "}
                        {this.state.order.invoiceDetails.individualID}
                        <br />
                      </>
                    )}
                  KDV Dahil Tutar:{" "}
                  {(
                    this.state.order.pricing.price +
                    (this.state.order.pricing.bonus
                      ? parseFloat(this.state.order.pricing.bonus)
                      : 0)
                  ).toFixed(2)}
                  ₺
                </Typography>
              </div>
            </Badge>
          )}

          {this.state.order.vehicle == 6 && (
            <Badge style={{ marginTop: 24, padding: 0, overflow: "hidden", ...leftColumnStyle }}>
              <EnterpriseCardHeader
                eyebrow="Planlama"
                title="Müsaitlik Takvimi"
                description="Planlanan zaman aralıklarını ve seçilen uygunluk durumunu görüntüleyin."
              />
              <div style={{ padding: "20px 24px 24px 24px" }}>
                {this.state.order.kioskId == undefined && (
                  <TimetableComponent
                    onTimesChanged={(dates) => {
                      if (this.state.editing) {
                        this.state.order.times = dates;
                        this.forceUpdate();
                      }
                    }}
                    timeStartDate={this.state.order.timeStartDate}
                    selectedDates={this.state.order.times}
                  />
                )}

                {this.state.order.kioskId != undefined && (
                  <JYSKTimetableComponent
                    onTimesChanged={(dates) => {
                      if (this.state.editing) {
                        this.state.order.times = dates;
                        this.forceUpdate();
                      }
                    }}
                    timeStartDate={this.state.order.timeStartDate}
                    selectedDates={this.state.order.times}
                  />
                )}
              </div>
            </Badge>
          )}

          {this.state.order.items != undefined && (
            <Badge style={{ marginTop: 24, padding: 0, overflow: "hidden", ...leftColumnStyle }}>
              <EnterpriseCardHeader
                eyebrow="Sipariş İçeriği"
                title="Ürün Listesi"
                description="Siparişte yer alan tüm ürünleri ve detaylarını görüntüleyin."
                badge={
                  <div
                    style={{
                      padding: "10px 14px",
                      borderRadius: 10,
                      backgroundColor: "#EFF4FF",
                      border: "1px solid #DCE9FF",
                    }}
                  >
                    <Typography
                      style={{ fontSize: 12, fontWeight: 600, color: "#3525CD" }}
                    >
                      {this.state.order.items.length} ürün
                    </Typography>
                  </div>
                }
              />
              <div
                style={{
                  padding: "20px 24px 24px 24px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                {this.state.order.items.map((x, i) => (
                  <ItemDescription item={x} key={i} />
                ))}
              </div>
            </Badge>
          )}

          {this.state.order.review != undefined && (
            <div style={leftColumnStyle}>
              <Review review={this.state.order.review} />
            </div>
          )}

          <Badge style={{ marginTop: 24, padding: 0, overflow: "hidden", ...leftColumnStyle }}>
            <EnterpriseCardHeader
              eyebrow="Saha Görünümü"
              title="Canlı Harita ve Güzergah"
              description="Güzergah görünümü ve en güncel sürücü konumu."
              badge={
                lastLocationUpdateDate != undefined ? (
                  <div
                    style={{
                      padding: "10px 14px",
                      borderRadius: 10,
                      backgroundColor: "#EFF4FF",
                      border: "1px solid #DCE9FF",
                    }}
                  >
                    <Typography style={{ fontSize: 12, fontWeight: 600, color: "#3525CD" }}>
                      Son konum güncellemesi
                    </Typography>
                    <Typography style={{ marginTop: 4, fontSize: 13, color: "#475467" }}>
                      {lastLocationUpdateDate.toLocaleString("tr-TR")}
                    </Typography>
                  </div>
                ) : undefined
              }
            />

            <div
              style={{
                height: 350,
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              <MapContainer
                ref={(a) => {
                  if (this.mapContainer == undefined && a != undefined) {
                    this.mapContainer = a;
                    this.mapContainer.fitBounds(this.mapBounds, {
                      padding: [100, 100],
                      animate: false,
                    });
                  }
                }}
                center={[41.07011330219962, 29.025937852318005]}
                style={{ width: "100%", height: "100%" }}
                zoom={10.5}
                scrollWheelZoom={true}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              {/* {Towns.map((x, i) => <Marker key={i} position={[x.geolocation.lat, x.geolocation.lon]}>
    <Popup>
      {x.name}
    </Popup>
  </Marker>)} */}
              {driverMarkerPosition && (
                <Marker
                  icon={driverMapIcon}
                  position={[driverMarkerPosition[1], driverMarkerPosition[0]]}
                >
                  <Popup>
                    <div
                      style={{
                        minWidth: 190,
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        padding: "2px 0",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: "#0f172a",
                        }}
                      >
                        {this.state.order.driverName || "Sürücü konumu"}
                      </Typography>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        <Typography sx={{ fontSize: 12, color: "#475569" }}>
                          Tahmini mesafe:{" "}
                          {formatOrderDistance(driverPickupDistance)}
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: "#475569" }}>
                          Alım noktasına ETA: {driverPickupEta}
                        </Typography>
                      </div>
                    </div>
                  </Popup>
                </Marker>
              )}
              <Marker
                icon={pickupMapIcon}
                opacity={this.state.order.currentWaypoint == 0 ? 1 : 0.5}
                position={[
                  this.state.order.from.coordinates[1],
                  this.state.order.from.coordinates[0],
                ]}
              >
                <Popup>Alım Noktası</Popup>
              </Marker>

              <Marker
                icon={greenIcon}
                opacity={this.state.order.currentWaypoint == 1 ? 1 : 0.5}
                position={[
                  this.state.order.to.coordinates[1],
                  this.state.order.to.coordinates[0],
                ]}
              >
                <Popup>Konum #1</Popup>
              </Marker>

                {this.polyLine != undefined && (
                  <Polyline positions={this.polyLine} />
                )}

                {/* {this.state.order.waypoints.map((x, i) => <Marker key={i} position={[x.loc.coordinates[1], x.loc.coordinates[0]]}>
    <Popup>
      {x.name} • {x.vehicles.map((x) => types[x.type]).join(",")} • {(x.credits+x.freeCredits).toFixed(2)}₺
      <br/>
      {new Date(x.loc.time).toLocaleString()}
      {console.log(x)}
    <br></br>
      <a href={'../driver/'+x._id}>{x._id}</a>
    </Popup>
  </Marker>)} */}
              </MapContainer>
            </div>
          </Badge>

          {this.state.order.batchableOrders != undefined && (
            <Badge style={{ marginTop: 50, padding: 0, ...leftColumnStyle }}>
              <div style={{ padding: 24 }}>
                <Typography variant="h6">Yakın Siparişler</Typography>
              </div>

              <DataGrid
                autoHeight
                rows={this.state.order.batchableOrders}
                columns={[
                  {
                    field: "ID",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    renderCell: (params) => (
                      <OrderIDTableCell order={params.row} />
                    ),
                    valueGetter: (params, row) =>
                      "#" + row._id.toString().substring(18).toUpperCase(),
                  },
                  {
                    field: "DURUM",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    renderCell: (params) => {
                      const v = STATUS[params.row.status];
                      return (
                        <>
                          <div
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                              paddingLeft: 10,
                              paddingRight: 10,
                              borderRadius: 20,
                              width: "fit-content",
                              height: "fit-content",
                              backgroundColor: STATUS[params.row.status].color,
                            }}
                          >
                            <Typography
                              sx={{ color: "white", fontWeight: "700" }}
                              variant="body2"
                            >
                              {STATUS[params.row.status].t}
                            </Typography>
                          </div>
                          {params.row.invoiceDetails != undefined &&
                            params.row.invoiceDetails.status != 10 && (
                              <div
                                style={{
                                  paddingTop: 5,
                                  marginLeft: 5,
                                  paddingBottom: 5,
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  borderRadius: 20,
                                  width: "fit-content",
                                  height: "fit-content",
                                  backgroundColor:
                                    params.row.invoiceDetails.status == 1
                                      ? "yellow"
                                      : "crimson",
                                }}
                              >
                                <Typography
                                  sx={{ color: "white", fontWeight: "700" }}
                                  variant="body2"
                                >
                                  {params.row.invoiceDetails.status == 1
                                    ? "F. Onay"
                                    : "F. Yok"}
                                </Typography>
                              </div>
                            )}
                        </>
                      );
                    },
                  },
                  {
                    field: "Araç",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    valueGetter: (params, row) => VEHICLE_NAMES[row.vehicle],
                  },
                  {
                    field: "Nereden",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    valueGetter: (params, row) =>
                      API.allowedCities[row.city].ilceler[row.from.subId],
                  },
                  {
                    field: "Nereye",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    valueGetter: (params, row) =>
                      API.allowedCities[row.city].ilceler[row.to.subId],
                  },
                  {
                    field: "Sürücü",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    renderCell: (params) => (
                      <a
                        style={{
                          textDecoration: "underline",
                          color: "#0000EE",
                        }}
                        href={
                          params.row.driver?.name
                            ? "../driver/" + params.row.driver._id
                            : undefined
                        }
                      >
                        {params.row.driver?.name || ""}
                      </a>
                    ),
                  },
                  {
                    field: "Ayar. Tarih",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    valueGetter: (params, row) =>
                      new Date(row.date).toLocaleString("tr-TR"),
                  },
                  {
                    field: "Veriliş Tarih",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    flex: 1,
                    valueGetter: (params, row) =>
                      new Date(
                        parseInt(row._id.substring(0, 8), 16) * 1000,
                      ).toLocaleString("tr-TR"),
                  },
                  {
                    field: " ",
                    cellClassName: (params) =>
                      params.row.assignedWorker?.name == API.user.name
                        ? "assignedRow"
                        : undefined,
                    renderCell: (params) => {
                      return (
                        <a href={"../order/" + params.row._id}>
                          <Button>
                            <ArrowForwardIcon />
                          </Button>
                        </a>
                      );
                      // return <Link to={'../order/' + params.row._id} ><Button><ArrowForwardIcon /></Button></Link>
                    },
                  },
                ]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 50, page: 0 } },
                }}
                slotProps={{
                  pagination: { showFirstButton: true, showLastButton: true },
                }}
                onPaginationModelChange={(model) => {
                  // this.setState({orders: []});
                  this.getOrders(model.page);
                }}
                pageSizeOptions={[50]}
                paginationMode="client"
                getRowId={(row) => row._id}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#F3F4F6",
                    borderRadius: 0,
                  },
                }}
              />
            </Badge>
          )}

          <Badge
            style={{
              marginTop: 24,
              padding: 0,
              paddingBottom: 24,
              ...leftColumnStyle,
            }}
          >
            <EnterpriseCardHeader
              eyebrow="Finans"
              title="Ödeme Detayları"
              description={`Ödeme yöntemi: ${getPanelPaymentMethodLabel(this.state.order.paymentMethod)}`}
            />

            <DetailText editable={false} label={"Servis Süresi"} value={time} />

            <DetailText
              editable={false}
              label={"Ödeme Tipi"}
              value={
                this.state.order.paymentMethod == 1
                  ? "Nakit Ödeme"
                  : this.state.order.paymentMethod == 5
                    ? "Kapıda Online Kredi Kartı"
                    : this.state.order.paymentMethod == 6
                      ? "Cari Hesap"
                      : "Kredi Kartı"
              }
            />

            <DetailText
              editable={false}
              label={"Baz Fiyat"}
              value={baseFee.toFixed(2)}
            />
            {this.state.order.pricing.bridges.map((x, i) => (
              <DetailText
                editable={false}
                label={x.desc ? x.desc.tr : "Köprü Geçiş #" + x.id}
                key={i}
                value={x.price.toFixed(2)}
              />
            ))}
            {this.state.order.additionals.map((x, i) => {
              if (!x) return <></>;

              return (
                <DetailText
                  editable={false}
                  label={
                    ADDITIONALS[i] +
                    (i == 4 && this.state.order.vehicle == 6
                      ? " (Ne Kadar Gerekiyorsa)"
                      : typeof x == "number"
                        ? " x" + x
                        : "")
                  }
                  key={i}
                  value={this.state.order.additionalPrices[i] * 0.85}
                />
              );
            })}
            {this.state.order.pricing.bonus && (
              <DetailText
                editable={false}
                label={"Bonus"}
                value={this.state.order.pricing.bonus.toFixed(2)}
              />
            )}
            {this.state.order.coupon && (
              <DetailText
                editable={false}
                label={
                  "Kupon" +
                  (this.state.order.coupon.identifier
                    ? " (" + this.state.order.coupon.identifier + ")"
                    : " (" + this.state.order.coupon.code + ")" || "")
                }
                value={"-" + this.state.order.coupon.discount.toFixed(2)}
              />
            )}
            <DetailText
              editable={false}
              label={"Komisyon"}
              value={this.state.order.pricing.commision.toFixed(2)}
            />
            <DetailText
              editable={false}
              label={"Toplam Ödeme"}
              value={(
                this.state.order.pricing.price +
                (this.state.order.pricing.bonus
                  ? parseFloat(this.state.order.pricing.bonus)
                  : 0)
              ).toFixed(2)}
            />
            <DetailText
              editable={false}
              label={"Sürücüye Geçecek"}
              value={(
                this.state.order.pricing.price +
                (this.state.order.pricing.bonus
                  ? parseFloat(this.state.order.pricing.bonus)
                  : 0) -
                this.state.order.pricing.commision
              ).toFixed(2)}
            />
          </Badge>

          </div>

          <div
            style={{
              minWidth: 0,
              position: isCompactLayout ? "static" : "sticky",
              top: 16,
              alignSelf: "start",
            }}
          >
          <Badge
            style={{
              marginTop: 8,
              padding: 0,
              paddingBottom: 24,
              border: "none",
              boxShadow: "0 14px 30px rgba(15, 23, 42, 0.07)",
              ...rightColumnStyle,
            }}
          >
            <EnterpriseCardHeader
              compact
              eyebrow="Sipariş Takibi"
              title="Sipariş Zaman Çizelgesi"
              description="Siparişin yaşam döngüsündeki güncellemeleri, atamaları ve önemli olayları izleyin."
            />

            {operatorAssignmentLogs.length > 0 && (
              <div
                style={{
                  marginLeft: 20,
                  marginRight: 20,
                  marginBottom: 18,
                  borderRadius: 14,
                  overflow: "hidden",
                  boxShadow: "0 10px 24px rgba(15, 23, 42, 0.08)",
                }}
              >
                <button
                  type="button"
                  aria-expanded={this.state.operatorHistoryExpanded}
                  onClick={() =>
                    this.setState((prevState) => ({
                      operatorHistoryExpanded: !prevState.operatorHistoryExpanded,
                    }))
                  }
                  style={{
                    width: "100%",
                    border: 0,
                    padding: "18px 20px",
                    background: "#F8FAFC",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    textAlign: "left",
                    gap: 12,
                  }}
                >
                  <div>
                    <Typography style={{ fontWeight: 700, color: "#0F172A" }}>
                      Operatör Atama Geçmişi ({operatorAssignmentLogs.length} değişiklik)
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: "#64748B", marginTop: 4, lineHeight: 1.5 }}
                    >
                      Tüm operatör transferlerini görmek için genişletin.
                    </Typography>
                  </div>
                  {this.state.operatorHistoryExpanded ? (
                    <ExpandMoreIcon sx={{ color: "#475467" }} />
                  ) : (
                    <ChevronRightIcon sx={{ color: "#475467" }} />
                  )}
                </button>

                {this.state.operatorHistoryExpanded && (
                  <div style={{ backgroundColor: "white" }}>
                    {operatorAssignmentLogs.map((log, index) => (
                      <OrderLogs key={`operator-log-${index}`} value={log} />
                    ))}
                  </div>
                )}
              </div>
            )}

            {otherOrderLogs.map((log, index) => (
              <div
                key={index}
                style={{
                  marginLeft: 14,
                  marginRight: 14,
                  marginBottom: 12,
                  borderRadius: 14,
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  boxShadow: "0 8px 20px rgba(15, 23, 42, 0.06)",
                }}
              >
                <OrderLogs value={log} />
              </div>
            ))}
          </Badge>

          {showManageOrderSection && (
            <Badge
              style={{
                marginTop: 24,
                padding: 0,
                overflow: "hidden",
                ...rightColumnStyle,
              }}
            >
              <button
                type="button"
                onClick={this.toggleManageOrderPanel}
                style={{
                  padding: 0,
                  width: "100%",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  borderBottom:
                    this.state.manageOrderExpanded && manageOrderFeedItems.length > 0
                      ? "0.5px solid #E8E8E0"
                      : "none",
                }}
              >
                <EnterpriseCardHeader
                  compact
                  eyebrow="Sipariş Değişiklikleri"
                  title="Talep ve Revizyon Geçmişi"
                  description="Müşteri tarafından talep edilen değişiklikleri ve bunların son durumunu görüntüleyin."
                  badge={
                    <div
                      style={{
                        fontSize: 11,
                        background: "#E6F1FB",
                        color: "#185FA5",
                        borderRadius: 20,
                        padding: "4px 10px",
                        fontWeight: 600,
                      }}
                    >
                      {manageOrderFeedItems.length} güncelleme
                    </div>
                  }
                  action={
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      {this.state.manageOrderLoading && <CircularProgress size={18} />}
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={this.state.manageOrderLoading}
                        onClick={(event) => {
                          event.stopPropagation();
                          this.loadManageOrderData();
                        }}
                      >
                        Yenile
                      </Button>
                      <KeyboardArrowDownIcon
                        sx={{
                          color: "#667085",
                          transform: this.state.manageOrderExpanded
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.2s",
                        }}
                      />
                    </div>
                  }
                />
              </button>

              {this.state.manageOrderExpanded &&
                manageOrderFeedItems.length === 0 &&
                !this.state.manageOrderLoading && (
                <div style={{ padding: "18px" }}>
                  <Typography style={{ color: "#64748B", fontSize: 12 }}>
                    Henüz müşteriye yansıyan bir sipariş değişikliği yok.
                  </Typography>
                </div>
              )}

              {this.state.manageOrderExpanded &&
                manageOrderFeedItems.map((item, index) => {
                  const itemKey = item.id || index;
                  const isOpen = !!this.state.manageOrderOpenItems[itemKey];

                  return (
                <div
                  key={itemKey}
                  style={{
                    margin: "12px 14px",
                    border: "1px solid #EBF1F8",
                    borderRadius: 14,
                    overflow: "hidden",
                    background:
                      "linear-gradient(180deg, rgba(250,252,255,1) 0%, rgba(255,255,255,1) 100%)",
                    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => this.toggleManageOrderItem(itemKey)}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 12,
                      padding: "16px 18px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <Typography style={{ fontSize: 13, fontWeight: 500 }}>
                        {item.title}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: 11,
                          color: "#64748B",
                          marginTop: 4,
                          lineHeight: 1.5,
                          wordBreak: "break-word",
                        }}
                      >
                        {item.summary}
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flexShrink: 0,
                      }}
                    >
                      <Typography style={{ fontSize: 11, color: "#64748B" }}>
                        {item.time
                          ? new Date(item.time).toLocaleTimeString("tr-TR", {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : ""}
                      </Typography>
                      <KeyboardArrowDownIcon
                        sx={{
                          fontSize: 16,
                          color: "#ccc",
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.2s",
                        }}
                      />
                    </div>
                  </button>

                  {isOpen && (
                  <div style={{ padding: "0 18px 18px 18px" }}>
                    <Typography
                      style={{
                        fontSize: 12,
                        color: "#64748B",
                        textDecoration: "line-through",
                        marginBottom: 4,
                        whiteSpace: item.preserveWhitespace ? "pre-wrap" : "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.oldValue}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        color:
                          item.variant === "blue"
                            ? "#185FA5"
                            : item.variant === "green"
                              ? "#3B6D11"
                              : "#854F0B",
                        whiteSpace: item.preserveWhitespace ? "pre-wrap" : "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.newValue}
                    </Typography>
                    {item.meta && (
                      <Typography
                        style={{ fontSize: 11, color: "#64748B", marginTop: 6 }}
                      >
                        {item.meta}
                      </Typography>
                    )}
                  </div>
                  )}
                </div>
                  );
                })}

            </Badge>
          )}

          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "flex-end",
              marginTop: 24,
              ...rightColumnStyle,
            }}
          >
            <Badge style={{ padding: 0, width: "100%" }}
            >
              <EnterpriseCardHeader
                compact
                eyebrow="Operasyon Akışı"
                title="Yetkili Güncellemeleri"
                description="İç operasyon notları ve ek gelişmeler için bu alanı kullanın."
                action={
                  <Button
                    onClick={() => {
                      this.setState({
                        addHistoryUpdateModalOpen: true,
                        addHistoryUpdateText: "",
                      });
                    }}
                    variant="contained"
                  >
                    Gelişme Ekle
                  </Button>
                }
              />
            </Badge>
          </div>

          </div>

          {/* {this.state.driver.vehicles && this.state.driver.vehicles.map((vehicle, i) => <Badge style={{marginTop:24, padding:0, paddingBottom:24}} key={i}>
                
                <Typography style={{marginBottom:24, marginLeft:24, marginTop:24}} variant='h6'>ARAÇ #{i}</Typography>

                <DetailText onChange={(e) => {vehicle.plate = e; this.forceUpdate()}} first label={"Plaka"} value={vehicle.plate} />
                <DetailText customEdit={() => <Select onChange={(e) => {vehicle.type = e.target.value; this.forceUpdate()}} value={vehicle.type} sx={{padding:0, "& .MuiOutlinedInput-input": {paddingTop: "7px", paddingBottom:"7px", paddingLeft:"14px", paddingRight:"14px"}}} style={{position:"absolute", left:"20%"}}>
                    <MenuItem value={0}>Motorsiklet</MenuItem>
                    <MenuItem value={2}>Doblo</MenuItem>
                    <MenuItem value={3}>Minivan</MenuItem>
                    <MenuItem value={4}>Panelvan</MenuItem>
                    <MenuItem value={5}>Kamyonet</MenuItem>
                    
                </Select>} label={"Araç Tipi"} value={VEHICLE_NAMES[vehicle.type]} />
                
                
            </Badge>)} */}

          {/* <Badge style={{marginTop:24,padding:0}}>
                <div style={{padding:24}}>
                <Typography variant='h6'>Son Siparişler</Typography>
                
                </div>
            <DataGrid
                autoHeight
                
                rows={this.state.driver.orders.map((x,i) => ({id:i,order:x,Tarih: dateFromObjectId(x._id).toLocaleString("tr-TR"),Araç: VEHICLE_NAMES[x.vehicle],Durum: (x.status == -1 && x.driver == this.state.driver._id)?11:(x.driver == this.state.driver._id)?x.status:12,ID: x._id.substring(0,7).toUpperCase()}))}
                columns={[{field: "ID",flex: 1}, {field: "Müşteri",flex: 1,renderCell: (params) => <RouterLink to={'/client/'+params.row.order.clientId}><Link>{params.row.order.clientId}</Link></RouterLink>},{field: "Tarih",flex: 1},{field:"Araç", flex:1}, {field: "Durum",flex: 1, renderCell: (params) => <div style={{paddingTop:5, paddingBottom:5, paddingLeft:10, paddingRight:10,borderRadius:20, backgroundColor:STATUS[params.value].color}}>
                    <Typography sx={{color:"white",fontWeight:"700"}} variant='body2'>{STATUS[params.value].t}</Typography>
                </div>}]}
                pageSize={10}
                rowsPerPageOptions={[10]}
                
                sx={{"& .MuiDataGrid-columnHeaders": {
                    backgroundColor:"#F3F4F6",
                    borderRadius:0,
                    
                }}}
            />
            </Badge> */}

          {IN_EDIT_MODE && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 24,
                alignItems: "center",
              }}
            >
              {!this.state.saving && (
                <Button
                  onClick={() => {
                    this.setState({ saving: true });

                    API.fetch("saveorder", this.state.order).then((e) => {
                      this.setState({ saving: false, editing: false });
                    });
                  }}
                  variant="contained"
                  color="success"
                  size="medium"
                >
                  Kaydet
                </Button>
              )}
              {this.state.saving && <CircularProgress />}
            </div>
          )}

          </div>
        </div>

        <Dialog
          open={this.state.invoiceApprovalDialogOpen}
          onClose={() => {
            this.closeInvoiceApprovalDialog();
          }}
          aria-labelledby="invoice-approval-dialog-title"
          aria-describedby="invoice-approval-dialog-description"
        >
          <DialogTitle id="invoice-approval-dialog-title">
            Fatura Tipi Seçin
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="invoice-approval-dialog-description">
              Faturayı onaylamadan önce fatura tipini seçin.
            </DialogContentText>
            <div style={{ marginTop: 16 }}>
              <ButtonGroup variant="outlined" size="small">
                {ORDER_INVOICE_TYPE_OPTIONS.map((invoiceType) => {
                  const selected = this.state.pendingInvoiceType == invoiceType;

                  return (
                    <Button
                      key={invoiceType}
                      variant={selected ? "contained" : "outlined"}
                      onClick={() => {
                        this.setState({ pendingInvoiceType: invoiceType });
                      }}
                    >
                      {ORDER_INVOICE_TYPE_LABELS[invoiceType]}
                    </Button>
                  );
                })}
              </ButtonGroup>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.closeInvoiceApprovalDialog();
              }}
              disabled={this.state.approvingInvoice}
            >
              İptal
            </Button>
            <Button
              onClick={() => {
                this.approveInvoice();
              }}
              disabled={
                this.state.approvingInvoice ||
                !ORDER_INVOICE_TYPE_OPTIONS.includes(
                  this.state.pendingInvoiceType,
                )
              }
              variant="contained"
              color="success"
            >
              {this.state.approvingInvoice ? "Onaylanıyor..." : "Onayla"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.assignDriverModalOpen}
          onClose={() => {
            this.setState({ assignDriverModalOpen: false });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Sürücü Ata</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div style={{ width: "80vw", maxWidth: 400 }}>
                {this.state.selectedDriverToAssign == undefined && (
                  <>
                    <Typography style={{ marginBottom: 10 }}>Sürücü</Typography>
                    <SearchBarComponent
                      onValueSelected={(v) => {
                        if (!v) return;

                        this.setState({ selectedDriverToAssign: v });
                      }}
                      search={{ drivers: true }}
                    />
                  </>
                )}
                {this.state.selectedDriverToAssign != undefined && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      gap: 10,
                      alignItems: "center",
                    }}
                  >
                    <Typography>
                      {this.state.selectedDriverToAssign.label}
                    </Typography>
                    <Button
                      onClick={() =>
                        this.setState({ selectedDriverToAssign: undefined })
                      }
                    >
                      X
                    </Button>
                  </div>
                )}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ assignDriverModalOpen: false });
              }}
            >
              İptal
            </Button>

            <Button
              disabled={this.state.selectedDriverToAssign == undefined}
              variant="contained"
              onClick={() => {
                global.showLoadingPanel();

                API.fetch("assigndriver", {
                  _id: this.state.order._id,
                  driver: this.state.selectedDriverToAssign._id,
                }).then((e) => {
                  global.hideLoadingPanel();
                  if (e.error) {
                    global.showPopup("Hata", e.error);
                  } else {
                    window.location.reload();
                  }
                });
                this.setState({ assignDriverModalOpen: false });
              }}
            >
              Ata
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.addHistoryUpdateModalOpen}
          onClose={() => {
            this.setState({ addHistoryUpdateModalOpen: false });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Sipariş Gelişmesi Ekle
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div style={{ width: "85vw", maxWidth: 400 }}>
                <TextareaAutosize
                  autoFocus
                  placeholder="Gelişme hakkında not... (Gizli)"
                  style={{
                    border: "1px solid blue",
                    flex: 1,
                    width: "100%",
                    padding: 10,
                  }}
                  value={this.state.addHistoryUpdateText}
                  onChange={(e) => {
                    this.setState({
                      addHistoryUpdateText: e.currentTarget.value,
                    });
                  }}
                  minRows={3}
                />
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ addHistoryUpdateModalOpen: false });
              }}
            >
              İptal
            </Button>

            <Button
              disabled={!this.state.addHistoryUpdateText}
              variant="contained"
              onClick={() => {
                this.setState({ addHistoryUpdateModalOpen: false });
                global.showLoadingPanel();

                API.fetch("addworkerorderupdate", {
                  _id: this.state.order._id,
                  text: this.state.addHistoryUpdateText,
                }).then((e) => {
                  if (e.error) {
                    global.hideLoadingPanel();
                    global.showPopup("Hata", e.error);
                    this.setState({ addHistoryUpdateModalOpen: true });
                  } else {
                    window.location.reload();
                  }
                });
              }}
            >
              Ekle
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.sendPaymentLinkModalOpen}
          onClose={() => {
            this.setState({
              sendPaymentLinkModalOpen: false,
              sendPaymentLinkPhoneNumber: "",
            });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Ödeme Linki Gönderme
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div style={{ width: "85vw", maxWidth: 400 }}>
                <Typography>Girilmiş Telefon Numaraları</Typography>
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    flexWrap: "wrap",
                    marginTop: 10,
                    marginBottom: 5,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() =>
                      this.setState({
                        sendPaymentLinkPhoneNumber:
                          this.state.order.client.phone,
                      })
                    }
                  >
                    Müşteri Kimliği {this.state.order.client.phone.slice(3)}
                  </Button>
                  {[
                    this.state.order.from,
                    ...this.state.order.waypoints,
                    this.state.order.to,
                  ]
                    .filter(
                      (x) =>
                        x.contactNO != undefined && x.contactNO.trim() != "",
                    )
                    .map((x, i) => (
                      <Button
                        variant="contained"
                        key={i}
                        onClick={() =>
                          this.setState({
                            sendPaymentLinkPhoneNumber: "+90" + x.contactNO,
                          })
                        }
                      >
                        {i + 1}. konum {x.contactName || ""} {x.contactNO}
                      </Button>
                    ))}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography>Telefon Numarası</Typography>
                  <MuiTelInput
                    forceCallingCode
                    style={{ width: "fit-content" }}
                    defaultCountry="TR"
                    value={this.state.sendPaymentLinkPhoneNumber}
                    onChange={(e) => {
                      this.setState({ sendPaymentLinkPhoneNumber: e });
                    }}
                    disableDropdown
                    onlyCountries={["TR"]}
                  />
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ sendPaymentLinkModalOpen: false });
              }}
            >
              İptal
            </Button>

            <Button
              disabled={
                this.state.sendPaymentLinkPhoneNumber.replaceAll(/ /g, "")
                  .length != 13
              }
              variant="contained"
              onClick={() => {
                this.setState({ sendPaymentLinkModalOpen: false });
                global.showLoadingPanel();

                API.fetch("sendonlinepaymentlink", {
                  _id: this.state.order._id,
                  phone: this.state.sendPaymentLinkPhoneNumber.replaceAll(
                    / /g,
                    "",
                  ),
                }).then((e) => {
                  if (e.error) {
                    global.hideLoadingPanel();
                    global.showPopup("Hata", e.error);
                    this.setState({ sendPaymentLinkModalOpen: true });
                  } else {
                    global.hideLoadingPanel();
                  }
                });
              }}
            >
              Gönder
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.notificationCenterModalOpen}
          onClose={() => {
            this.setState({
              notificationCenterModalOpen: false,
              notificationCenter: { title: {}, body: {} },
            });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div style={{ width: "85vw", maxWidth: 500 }}>
                <div
                  style={{
                    flex: 1,
                    justifyContent: "space-between",
                    display: "flex",
                  }}
                >
                  <Typography variant="h6" color="black">
                    Bildirim Gönderme
                  </Typography>
                  <Button
                    id="basic-button"
                    aria-controls={
                      this.state.notificationTemplatesDropdownOpen
                        ? "basic-menu"
                        : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={
                      this.state.notificationTemplatesDropdownOpen
                        ? "true"
                        : undefined
                    }
                    onClick={(e) => {
                      this.anchorT = e.currentTarget;
                      this.setState({
                        notificationTemplatesDropdownOpen:
                          !this.state.notificationTemplatesDropdownOpen,
                      });
                    }}
                    variant="contained"
                    style={{ alignSelf: "flex-end" }}
                  >
                    Şablonlar <ArrowDropDownIcon />
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={this.anchorT}
                    open={this.state.notificationTemplatesDropdownOpen}
                    onClose={() => {
                      this.setState({
                        notificationTemplatesDropdownOpen: false,
                      });
                    }}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    {global.cache.replies
                      .filter((s) => s.type == 1)
                      .map((s) => (
                        <MenuItem
                          onClick={() => {
                            this.setState({
                              notificationTemplatesDropdownOpen: false,
                              notificationCenter: {
                                ...this.state.notificationCenter,
                                title: { tr: s.titleTR, en: s.titleEN },
                                body: { tr: s.bodyTR, en: s.bodyEN },
                              },
                            });
                          }}
                        >
                          <div>
                            <p style={{ textAlign: "right" }}>{s.code}</p>
                            <p
                              style={{
                                fontSize: 10,
                                textAlign: "right",
                                maxWidth: 300,
                                textOverflow: "ellipsis",
                              }}
                            >
                              {s.titleTR + " " + s.bodyTR}
                            </p>
                          </div>
                        </MenuItem>
                      ))}
                  </Menu>
                </div>

                <Typography>
                  {this.state.notificationCenter.receiverType == 0
                    ? "Müşteri: "
                    : "Sürücü: "}{" "}
                  {this.state.notificationCenter.receiverName}
                </Typography>

                <Typography
                  variant="body1"
                  style={{ marginTop: 10, marginBottom: 5 }}
                >
                  Başlık
                </Typography>
                <TextField
                  fullWidth
                  value={this.state.notificationCenter.title.tr || ""}
                  onChange={(e) => {
                    this.state.notificationCenter.title.tr = e.target.value;
                    this.forceUpdate();
                  }}
                  size="small"
                  rows={3}
                  multiline
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                />

                <Typography
                  variant="body1"
                  style={{ marginTop: 10, marginBottom: 5 }}
                >
                  Metin
                </Typography>
                <TextField
                  fullWidth
                  value={this.state.notificationCenter.body.tr || ""}
                  onChange={(e) => {
                    this.state.notificationCenter.body.tr = e.target.value;
                    this.forceUpdate();
                  }}
                  size="small"
                  rows={3}
                  multiline
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ notificationCenterModalOpen: false });
              }}
            >
              İptal
            </Button>

            <Button
              disabled={
                !this.state.notificationCenter.receiverId ||
                (this.state.notificationCenter.title?.tr || "").length <= 0 &&
                (this.state.notificationCenter.body?.tr || "").length <= 0
              }
              variant="contained"
              onClick={() => {
                this.setState({ notificationCenterModalOpen: false });
                global.showLoadingPanel();

                API.fetch("sendnotifications", {
                  filters: {
                    _id: { $in: [this.state.notificationCenter.receiverId] },
                  },
                  receiverType: this.state.notificationCenter.receiverType,
                  data: { orderId: this.state.order._id },
                  title: this.state.notificationCenter.title,
                  body: this.state.notificationCenter.body,
                }).then((e) => {
                  global.hideLoadingPanel();

                  console.log(e);
                });
              }}
            >
              Gönder
            </Button>
          </DialogActions>
        </Dialog>

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.backdropVisible}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }
}

const Waypoint = (props) => {
  return (
    <>
      <DetailText
        editable={false}
        label={"Konum #" + props.title}
        noBorder={IN_EDIT_MODE}
        value={
          IN_EDIT_MODE
            ? props.waypoint.Label
            : API.getAddressLabel(props.waypoint)
        }
      />

      {!IN_EDIT_MODE &&
        (props.waypoint.contactName || props.waypoint.contactNO) && (
          <DetailText
            editable={false}
            label={"^ İrtibat"}
            value={
              (props.waypoint.contactName || "") +
              (props.waypoint.contactName && props.waypoint.contactNO
                ? " · "
                : "") +
              props.waypoint.contactNO
            }
          />
        )}
      {IN_EDIT_MODE && (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              paddingLeft: 24,
              paddingRight: 24,
              marginBottom: 10,
              marginTop: 5,
            }}
          >
            <WaypointDetailInput
              onChange={(t) => {
                props.waypoint.building = t;
                props.forceUpdate();
              }}
              label={"Bina:"}
              value={props.waypoint.building}
            />
            <div
              style={{
                width: 2,
                height: 20,
                opacity: 0.8,
                backgroundColor: "#121828",
              }}
            ></div>
            <WaypointDetailInput
              onChange={(t) => {
                props.waypoint.floor = t;
                props.forceUpdate();
              }}
              label={"Kat:"}
              value={props.waypoint.floor}
            />
            <div
              style={{
                width: 2,
                height: 20,
                opacity: 0.8,
                backgroundColor: "#121828",
              }}
            ></div>
            <WaypointDetailInput
              onChange={(t) => {
                props.waypoint.door = t;
                props.forceUpdate();
              }}
              label={"No:"}
              value={props.waypoint.door}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              paddingLeft: 24,
              paddingRight: 24,
              marginBottom: 10,
            }}
          >
            <WaypointDetailInput
              onChange={(t) => {
                props.waypoint.contactName = t;
                props.forceUpdate();
              }}
              label={"İrtibat Ad:"}
              value={props.waypoint.contactName}
            />
            <div
              style={{
                width: 2,
                height: 20,
                opacity: 0.8,
                backgroundColor: "#121828",
              }}
            ></div>
            <WaypointDetailInput
              onChange={(t) => {
                props.waypoint.contactNO = t;
                props.forceUpdate();
              }}
              label={"İrtibat Telefon: +90"}
              value={props.waypoint.contactNO}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              paddingLeft: 24,
              paddingRight: 24,
              borderBottom: "solid 1px #E6E8F0",
              marginBottom: 5,
              paddingBottom: 10,
              marginTop: 5,
            }}
          >
            <WaypointDetailInput
              onChange={(t) => {
                props.waypoint.details = t;
                props.forceUpdate();
              }}
              label={"Müşteri Notu:"}
              value={props.waypoint.details}
            />
          </div>
        </>
      )}
    </>
  );
};
const WaypointDetailInput = (props) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5, flex: 1 }}>
      <Typography style={{ fontWeight: "600" }}>{props.label}</Typography>
      <TextField
        onChange={(e) => props.onChange(e.currentTarget.value)}
        sx={{
          padding: 0,
          flex: 1,
          "& .MuiOutlinedInput-input": {
            paddingTop: "7px",
            paddingBottom: "7px",
            paddingLeft: "14px",
            paddingRight: "14px",
          },
        }}
        value={props.value}
      />
    </div>
  );
};

const LogisticAnalytic = (props) => {
  return (
    <Badge style={{ marginLeft: props.first ? 0 : 24 }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            backgroundColor: props.backgroundColor,
            width: 40,
            height: 40,
            borderRadius: 8,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          {props.icon}
        </div>

        <Typography style={{ marginLeft: 10 }} variant="h5">
          {props.value}
        </Typography>
      </div>
      <Typography
        style={{
          marginTop: 15,
          color: "rgb(101, 116, 139)",
          fontWeight: "400",
        }}
        variant="body2"
      >
        {props.title}
      </Typography>
    </Badge>
  );
};

const EnterpriseSummaryBlock = ({
  label,
  title,
  subtitle,
  titleColor = "#0B1C30",
}) => {
  const isNarrow = typeof window !== "undefined" ? window.innerWidth < 768 : false;

  return (
  <div
    style={{
      padding: isNarrow ? "0 0 2px 0" : "2px 0 4px 0",
      minWidth: 0,
    }}
  >
    <Typography
      style={{
        color: "#64748B",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        marginBottom: 10,
      }}
    >
      {label}
    </Typography>
    <Typography
      style={{
        fontSize: isNarrow ? 20 : 24,
        lineHeight: 1.3,
        fontWeight: 700,
        color: titleColor,
        letterSpacing: "-0.02em",
        wordBreak: "break-word",
      }}
    >
      {title}
    </Typography>
    <Typography
      style={{
        color: "#475467",
        fontSize: 14,
        marginTop: 6,
        lineHeight: 1.6,
        wordBreak: "break-word",
      }}
    >
      {subtitle}
    </Typography>
  </div>
  );
};

const EnterpriseDetailSection = ({ label, children, style }) => {
  const isNarrow = typeof window !== "undefined" ? window.innerWidth < 768 : false;

  return (
  <div
    style={{
      border: "1px solid #E2E8F0",
      borderRadius: 14,
      overflow: "hidden",
      backgroundColor: "#FFFFFF",
      ...style,
    }}
  >
    <div
      style={{
        padding: isNarrow ? "14px 16px" : "16px 20px",
        borderBottom: "1px solid #E2E8F0",
        backgroundColor: "#FAFBFC",
      }}
    >
      <Typography
        style={{
          color: "#475467",
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
        }}
      >
        {label}
      </Typography>
    </div>
    <div style={{ padding: isNarrow ? "0 16px 8px 16px" : "0 20px 8px 20px" }}>
      {children}
    </div>
  </div>
  );
};

const EnterpriseCardHeader = ({
  eyebrow,
  title,
  description,
  badge,
  action,
  compact = false,
}) => {
  const isNarrow = typeof window !== "undefined" ? window.innerWidth < 768 : false;

  return (
    <div
      style={{
        padding: isNarrow
          ? "18px 18px 14px 18px"
          : compact
            ? "18px 20px 14px 20px"
            : "20px 24px 16px 24px",
        borderBottom: "1px solid #E2E8F0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 12,
        flexWrap: "wrap",
        backgroundColor: "#FFFFFF",
      }}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        {eyebrow && (
          <Typography
            style={{
              color: "#64748B",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              marginBottom: 8,
            }}
          >
            {eyebrow}
          </Typography>
        )}
        <Typography
          style={{
            fontSize: isNarrow ? 22 : compact ? 20 : 24,
            lineHeight: 1.15,
            fontWeight: 700,
            color: "#0B1C30",
            letterSpacing: "-0.025em",
          }}
        >
          {title}
        </Typography>
        {description && (
          <Typography
            style={{
              marginTop: 6,
              color: "#64748B",
              fontSize: 14,
              lineHeight: 1.6,
              maxWidth: 560,
            }}
          >
            {description}
          </Typography>
        )}
      </div>

      {(badge || action) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          {badge}
          {action}
        </div>
      )}
    </div>
  );
};

const EnterpriseSectionDivider = ({ label }) => (
  <div
    style={{
      padding: "22px 24px 10px 24px",
      borderTop: "1px solid #E2E8F0",
      background:
        "linear-gradient(180deg, rgba(248,250,255,0.92) 0%, rgba(255,255,255,0) 100%)",
    }}
  >
    <Typography
      style={{
        color: "#64748B",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
      }}
    >
      {label}
    </Typography>
  </div>
);

const InvoicePreview = ({ url }) => {
  var extension = url.split("?")[0].split(".").pop().toLowerCase();
  const pageWidth =
    typeof window !== "undefined"
      ? Math.min(window.innerWidth - 48, 900)
      : 700;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {(extension.endsWith("png") ||
          extension.endsWith("jpeg") ||
          extension.endsWith("jpg")) && (
          <img src={url} style={{ maxWidth: "100%", height: "auto" }} />
        )}
        {extension.endsWith("pdf") && (
          <Document
            onLoadError={(error) => console.log("Inside Error", error)}
            file={{ url: url }}
          >
            <Page width={pageWidth} pageNumber={1} />
            {/* <Page pageNumber={pageNumber} /> */}
          </Document>
        )}
      </div>
    </div>
  );
};

const FilePreview = ({ file, urlBase, title, ...rest }) => {
  return (
    <div>
      {!IN_EDIT_MODE && (
        <Typography
          style={{
            marginBottom: 24,
            marginLeft: 24,
            marginTop: 24,
            textAlign: "center",
          }}
          variant="h6"
        >
          {title}
        </Typography>
      )}
      {IN_EDIT_MODE && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            style={{ marginBottom: 24, marginLeft: 24, marginTop: 24 }}
            variant="h6"
          >
            {title}
          </Typography>

          {file && !file.removed && (
            <div style={{ marginLeft: 10 }}>
              <Button
                onClick={() => {
                  rest.onClick();
                }}
                variant="outlined"
                color="error"
              >
                Sil
              </Button>
            </div>
          )}
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "center" }}>
        {file &&
          !file.removed &&
          (file.path.endsWith(".png") ||
            file.path.endsWith(".jpeg") ||
            file.path.endsWith(".jpg")) && (
            <img {...rest} src={urlBase + file.path} />
          )}
        {file && !file.removed && file.path.endsWith(".pdf") && (
          <Document file={{ url: urlBase + file.path }}>
            {/* <Page pageNumber={pageNumber} /> */}
          </Document>
        )}

        {file && file.removed && (
          <Typography variant="h6" color="crimson">
            KALDIRILDI
          </Typography>
        )}
      </div>
    </div>
  );
};

const DetailText = (props) => {
  const isNarrow = typeof window !== "undefined" ? window.innerWidth < 768 : false;
  const horizontalPadding = isNarrow ? 18 : 24;

  return (
    <div
      style={{
        position: "relative",
        flexDirection: "column",
        display: "flex",
        paddingLeft: horizontalPadding,
        paddingRight: horizontalPadding,
        paddingTop: isNarrow ? 16 : 14,
        paddingBottom: isNarrow ? 16 : 14,
        borderBottom: props.noBorder ? undefined : "solid 1px #E2E8F0",
        borderTop: props.first ? "solid 1px #E2E8F0" : "",
      }}
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: isNarrow ? "column" : "row",
          gap: isNarrow ? 10 : 18,
        }}
      >
        <div
          style={{
            maxWidth: isNarrow ? "100%" : 180,
            flex: isNarrow ? "unset" : 0.6,
            display: "flex",
            alignItems: props.centerLabel ? "center" : undefined,
          }}
        >
          <Typography
            style={{
              fontWeight: 600,
              fontSize: 12,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "#64748B",
            }}
          >
            {props.label}
          </Typography>
        </div>
        <div
          className="detailParent"
          style={{
            flex: 1,
            minWidth: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {(!IN_EDIT_MODE || props.editable == false) &&
            props.link == undefined && (
              <Typography
                {...props}
                style={{
                  fontSize: isNarrow ? 14 : 15,
                  color: "#0B1C30",
                  lineHeight: 1.5,
                  wordBreak: "break-word",
                  ...(props.style || {}),
                }}
              >
                {props.value}
              </Typography>
            )}
          {(!IN_EDIT_MODE || props.editable == false) &&
            props.link != undefined && (
              <Link to={props.link}>
                <Typography
                  {...props}
                  style={{
                    fontSize: isNarrow ? 14 : 15,
                    color: "#3525CD",
                    lineHeight: 1.5,
                    wordBreak: "break-word",
                    ...(props.style || {}),
                  }}
                >
                  {props.value}
                </Typography>
              </Link>
            )}
          {props.customEdit == undefined &&
            IN_EDIT_MODE &&
            props.editable != false && (
              <TextField
                onChange={(e) => props.onChange(e.currentTarget.value)}
                sx={{
                  padding: 0,
                  "& .MuiOutlinedInput-input": {
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                  },
                }}
                value={props.value}
              />
            )}
          {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()}
          {!IN_EDIT_MODE && props.children}
        </div>
        {/* 


        {(!IN_EDIT_MODE || props.editable == false) && <Typography {...props} style={{position:"absolute", left:window.innerWidth < 500?"40%":"20%"}}>{props.value}</Typography>}
        {props.customEdit == undefined && IN_EDIT_MODE &&  props.editable != false && <TextField onChange={(e) => props.onChange(e.currentTarget.value)} style={{position:"absolute",right:24, left:"20%", padding:0}} sx={{padding:0, "& .MuiOutlinedInput-input": {paddingTop: "7px", paddingBottom:"7px", paddingLeft:"14px", paddingRight:"14px"}}}  value={props.value} />}
        {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()} */}
      </div>

      {props.altComponent != undefined && props.altComponent}
    </div>
  );
};

// const DetailText = (props) => {
//     return <div  style={{position:"relative",display:"flex", paddingTop:10, paddingBottom:10,alignItems:"center", borderBottom:"solid 1px #E6E8F0", borderTop:(props.first?"solid 1px #E6E8F0":"")}}>

//         <Typography style={{fontWeight:"600", marginLeft:24}}>{props.label}</Typography>

//         {(!IN_EDIT_MODE || props.editable == false) && <Typography {...props} style={{position:"absolute", left:window.innerWidth < 500?"40%":"20%"}}>{props.value}</Typography>}
//         {props.customEdit == undefined && IN_EDIT_MODE &&  props.editable != false && <TextField onChange={(e) => props.onChange(e.currentTarget.value)} style={{position:"absolute",right:24, left:"20%", padding:0}} sx={{padding:0, "& .MuiOutlinedInput-input": {paddingTop: "7px", paddingBottom:"7px", paddingLeft:"14px", paddingRight:"14px"}}}  value={props.value} />}
//         {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()}
//     </div>
// }

const OrderLogs = (props) => {
  const isNarrow = typeof window !== "undefined" ? window.innerWidth < 768 : false;

  return (
    <>
      <DetailText
        altComponent={props.value.altComponent}
        label={props.value.label}
        editable={false}
      >
        <div
          style={{
            display: "flex",
            flexDirection: isNarrow ? "column" : "row",
            alignItems: isNarrow ? "flex-start" : "center",
            gap: isNarrow ? 8 : 0,
            minWidth: 0,
            width: "100%",
          }}
        >
          {(props.value.linkname == undefined ||
            props.value.linkname.startsWith(".")) && (
            <Typography style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}>
              <Link to={props.value.link}>{props.value.linkname}</Link>
              {props.value.value}{" "}
              {new Date(props.value.date).toLocaleString("tr-TR")}
            </Typography>
          )}

          {props.value.customElement == undefined &&
            props.value.linkname != undefined &&
            !props.value.linkname.startsWith(".") && (
              <Typography
                style={{
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  lineHeight: 1.6,
                }}
              >
                <a target={"_blank"} href={props.value.link}>
                  {props.value.linkname}
                </a>
                {props.value.value}{" "}
                {props.value.p ? (
                  <a
                    href="#"
                    onClick={() => {
                      window.open(
                        props.value.p,
                        "popup",
                        "width=400,height=600",
                      );
                    }}
                    style={{
                      display: "inline-block",
                      marginTop: isNarrow ? 6 : 0,
                    }}
                  >
                    Mesajlari Gör{" "}
                  </a>
                ) : (
                  <></>
                )}
                {new Date(props.value.date).toLocaleString("tr-TR")}
              </Typography>
            )}

          {props.value.customElement != undefined && props.value.customElement}

          {props.value.alt != undefined && props.value.alt}
        </div>
      </DetailText>
    </>
  );
};

// const OrderLogs = (props) => {
//     return <div style={{position:"relative",display:"flex", paddingTop:10, paddingBottom:10, borderBottom:"solid 1px #E6E8F0", borderTop:(props.first?"solid 1px #E6E8F0":"")}}>
//         <Typography style={{fontWeight:"600", marginLeft:24, width: 140}}>{props.value.label}</Typography>

//         <div style={{display:"flex", flex:1, alignItems:"center"}}>

//         {(props.value.linkname == undefined || props.value.linkname.startsWith(".")) && <Typography><Link to={props.value.link}>{props.value.linkname}</Link>{props.value.value} {new Date(props.value.date).toLocaleString("tr-TR")}</Typography>}

//         {props.value.customElement == undefined && (props.value.linkname != undefined && !props.value.linkname.startsWith(".")) && <Typography><a target={"_blank"} href={props.value.link}>{props.value.linkname}</a>{props.value.value} {props.value.p?<a href="#" onClick={() => {
//             window.open(props.value.p,'popup','width=400,height=600')
//         }}>Mesajlari Gör </a>:<></>}{new Date(props.value.date).toLocaleString("tr-TR")}</Typography>}

//         {props.value.customElement != undefined && props.value.customElement}

//         {props.value.alt != undefined && props.value.alt}
//         </div>
//     </div>
// }

const DetailLinkedText = (props) => {
  const isNarrow = typeof window !== "undefined" ? window.innerWidth < 768 : false;
  const horizontalPadding = isNarrow ? 16 : 24;

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: horizontalPadding,
        paddingRight: horizontalPadding,
        alignItems: "center",
        borderBottom: "solid 1px #E6E8F0",
        borderTop: props.first ? "solid 1px #E6E8F0" : "",
      }}
    >
      <Typography
        style={{
          fontWeight: "600",
          width: isNarrow ? "100%" : undefined,
          marginBottom: isNarrow ? 8 : 0,
        }}
      >
        {props.label}
      </Typography>

      {(!IN_EDIT_MODE || props.editable == false) && (
        <Link to={props.link}>
          <Typography
            style={{
              position: isNarrow ? "static" : "absolute",
              left: isNarrow ? undefined : "20%",
              wordBreak: "break-word",
            }}
          >
            {props.value}
          </Typography>
        </Link>
      )}
      {props.customEdit == undefined &&
        IN_EDIT_MODE &&
        props.editable != false && (
          <TextField
            onChange={(e) => props.onChange(e.currentTarget.value)}
            style={{
              position: isNarrow ? "static" : "absolute",
              right: isNarrow ? undefined : 24,
              left: isNarrow ? undefined : "20%",
              padding: 0,
              width: isNarrow ? "100%" : undefined,
            }}
            sx={{
              padding: 0,
              "& .MuiOutlinedInput-input": {
                paddingTop: "7px",
                paddingBottom: "7px",
                paddingLeft: "14px",
                paddingRight: "14px",
              },
            }}
            value={props.value}
          />
        )}
      {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()}
    </div>
  );
};
var dateFromObjectId = function (objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        border: "none",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.06)",
        borderRadius: 16,
        padding: 24,
        color: "#0B1C30",
        position: "relative",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

function convertMillisToTimeString(millis) {
  const hours = Math.floor(millis / (1000 * 60 * 60));
  const minutes = Math.floor((millis % (1000 * 60 * 60)) / (1000 * 60));

  let timeString = "";

  if (hours > 0) {
    timeString += `${hours} saat`;
  }

  if (minutes > 0) {
    if (timeString) timeString += " ";
    timeString += `${minutes} dakika`;
  }

  return timeString || "0 dakika";
}

function secondsToString(seconds) {
  // Calculate minutes and remaining seconds
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // Format the output string
  const formattedString =
    (minutes > 0 ? `${minutes}dakika ` : "") +
    (remainingSeconds > 0 ? `${remainingSeconds}saniye` : "");

  if (seconds <= 0) return "0sn";

  return formattedString;
}

function digit(num) {
  return `${num}`.padStart(2, "0");
}
